import { BudgetReportFileModel, File, FileDetails } from './file.models';
import { Coordination, Signing, Task, TaskHistoryItem } from './task.models';

import { PersonSearchType } from './enums';
import { convertFromUtcToLocal, getUid } from '../helpers/helpers';

export {
    File,
    FileDetails,
    Task,
    TaskHistoryItem,
    Coordination,
    Signing
}

export class Person {
    constructor(obj = {}) {
        this.id = obj.id || '';
        this.firstName = obj.firstName || '';
        this.middleName = obj.middleName || '';
        this.lastName = obj.lastName || '';
        this.firstNameEn = obj.firstNameEn;
        this.middleNameEn = obj.middleNameEn;
        this.lastNameEn = obj.lastNameEn;
        this.idCardNumber = obj.idCardNumber || '';
        this.idCardDateOfIssue = obj.idCardDateOfIssue ? convertFromUtcToLocal(obj.idCardDateOfIssue) : null;
        this.idCardIssuedBy = obj.idCardIssuedBy || '';
        this.personIdentification = new PersonIdentification(obj.personIdentification || {});
        this.genderTypeId = obj.genderTypeId || '';
        this.phone = obj.phone || '';
        this.mobilePhone = obj.mobilePhone || '';
        this.email = obj.email || '';
        this.position = obj.position || '';
        this.positionStr = obj.positionStr || '';
        this.positionStatisticId = obj.positionStatisticId || '';
        this.description = obj.description || '';
        this.userId = obj.userId || '';
        this.salutationId = obj.salutationId || '';
        this.educationDegreeId = obj.educationDegreeId || '';
        this.titleDegreeId = obj.titleDegreeId || '';
        this.institutionRegisterId = obj.institutionRegisterId || '';
        this.relatedUsername = obj.relatedUsername || '';
        this.relatedUserEmail = obj.relatedUserEmail || '';
        this.updatedBy = obj.updatedBy || '';
        this.updatedAt = obj.updatedAt ? obj.updatedAt : null;
        this.specifyInstitution = obj.specifyInstitution || false;
        this.institutionOther = obj.institutionOther || '';
        this.institutionOtherCountryId = obj.institutionOtherCountryId || 5251; // default data - Bulgaria;
        this.institutionOtherCityId = obj.institutionOtherCityId || 2643; // default data - Sofia, db table Cities
        this.institutionOtherCity = obj.institutionOtherCity || '';
        this.bankAccount = new BankAccount(obj.bankAccount || {});
        this.address = new Address(obj.address || {});

        // Details
        this.fullName = obj.fullName || '';
        this.fullNameEn = obj.fullNameEn || '';
        this.shortFullName = obj.shortFullName || '';
        this.shortFullNameEn = obj.shortFullNameEn || '';
        this.gender = obj.gender || '';
        this.genderEn = obj.genderEn || '';
        this.positionStatisticDetails = obj.positionStatisticDetails || '';
        this.positionStatisticDetailsEn = obj.positionStatisticDetailsEn || '';
        this.positionDetails = obj.positionDetails || '';
        this.positionDetailsEn = obj.positionDetailsEn || '';
        this.institutionDetails = obj.institutionDetails || '';
        this.institutionDetailsEn = obj.institutionDetailsEn || '';
        this.institutionLocationDetails = obj.institutionLocationDetails || '';
        this.institutionLocationDetailsEn = obj.institutionLocationDetailsEn || '';
        this.salutationDetails = obj.salutationDetails || '';
        this.salutationDetailsEn = obj.salutationDetailsEn || '';
        this.educationDegreeDetails = obj.educationDegreeDetails || '';
        this.educationDegreeDetailsEn = obj.educationDegreeDetailsEn || '';
        this.titleDegreeDetails = obj.titleDegreeDetails || '';
        this.titleDegreeDetailsEn = obj.titleDegreeDetailsEn || '';

        this.profileManagement = obj.profileManagement || false;
        this.areaOfAppeal = new AreaOfAppeal(obj.areaOfAppeal || {});
        this.selected = obj.selected || false;
    }
}

export class PersonDetails {
    constructor(obj = {}) {
        this.id = obj.id || 0;
        this.firstName = obj.firstName || '';
        this.middleName = obj.middleName || '';
        this.lastName = obj.lastName || '';
        this.idCardNumber = obj.idCardNumber || '';
        this.idCardDateOfIssue = obj.idCardDateOfIssue ? convertFromUtcToLocal(obj.idCardDateOfIssue) : null;
        this.idCardIssuedBy = obj.idCardIssuedBy || '';
        this.fullName = obj.fullName || '';
        this.personIdentification = new PersonIdentificationDetails(obj.personIdentification || {});
        this.genderType = obj.genderType || '';
        this.phone = obj.phone || '';
        this.mobilePhone = obj.mobilePhone || '';
        this.email = obj.email || '';
        this.position = obj.position || '';
        this.positionEn = obj.positionEn || '';
        this.description = obj.description || '';

        this.fullNameEn = obj.fullNameEn || '';
        this.shortFullName = obj.shortFullName || '';
        this.shortFullNameEn = obj.shortFullNameEn || '';
        this.gender = obj.gender || '';
        this.genderEn = obj.genderEn || '';
        this.positionStatisticDetails = obj.positionStatisticDetails || '';
        this.positionStatisticDetailsEn = obj.positionStatisticDetailsEn || '';
        this.positionStr = obj.positionStr || '';
        this.positionDetails = obj.positionDetails || '';
        this.positionDetailsEn = obj.positionDetailsEn || '';
        this.institutionDetails = obj.institutionDetails || '';
        this.institutionDetailsEn = obj.institutionDetailsEn || '';
        this.institutionLocationDetails = obj.institutionLocationDetails || '';
        this.institutionLocationDetailsEn = obj.institutionLocationDetailsEn || '';
        this.salutationDetails = obj.salutationDetails || '';
        this.salutationDetailsEn = obj.salutationDetailsEn || '';
        this.educationDegreeDetails = obj.educationDegreeDetails || '';
        this.educationDegreeDetailsEn = obj.educationDegreeDetailsEn || '';
        this.titleDegreeDetails = obj.titleDegreeDetails || '';
        this.titleDegreeDetailsEn = obj.titleDegreeDetailsEn || '';

        this.profileManagement = obj.profileManagement || false;
    }
}

export class ContactPerson {
    constructor(obj = {}) {
        this.id = obj.id;
        this.firstName = obj.firstName;
        this.middleName = obj.middleName;
        this.lastName = obj.lastName;
        this.email = obj.email;
        this.phone = obj.phone;
        this.mobilePhone = obj.mobilePhone;
    }
}

export class PersonIdentification {
    constructor(obj = {}) {
        this.identificationTypeId = obj.identificationTypeId || '';
        this.number = obj.number || '';
        this.id = obj.id || 0;
        this.identificationType = obj.identificationType || '';
        this.identificationTypeEn = obj.identificationTypeEn || '';
    }
}

export class PersonIdentificationDetails {
    constructor(obj = {}) {
        this.identificationType = obj.identificationType || '';
        this.number = obj.number || '';
        this.id = obj.id || '';
    }
}

export class ChangePassword {
    constructor(obj = {}) {
        this.id = obj.id || '';
        this.oldPassword = obj.oldPassword || '';
        this.newPassword = obj.newPassword || '';
        this.newPasswordConfirm = obj.newPasswordConfirm || '';
    }
}

export class OtherFields {
    constructor(obj = {}) {
        this.other1 = obj.other1 || '';
        this.other2 = obj.other2 || '';
    }
}

export class Address {
    constructor(obj = {}) {
        this.id = obj.id || '';
        this.postCode = obj.postCode || '';
        this.street = obj.street || '';
        this.num = obj.num || '';
        this.lat = obj.lat || 0;
        this.long = obj.long || 0;
        this.countryId = obj.countryId || 5251; // default data - Bulgaria
        this.settlementId = obj.settlementId || 2643; // default data - Sofia, db table Cities
        this.settlement = obj.settlement || '';
        this.cityName = obj.cityName || '';
        this.areaOfAppeal = new AreaOfAppeal(obj.areaOfAppeal || {});
    }
}

export class AddressDetails {
    constructor(obj = {}) {
        this.id = obj.id || 0;
        this.postCode = obj.postCode || '';
        this.street = obj.street || '';
        this.num = obj.num || '';
        this.lat = obj.lat || 0;
        this.long = obj.long || 0;
        this.settlementId = obj.settlementId | '';
        this.settlement = obj.settlement || ''; // default data - Sofia
        this.settlementEn = obj.settlementEn || ''; // default data - Sofia
        this.country = obj.country || ''; // default data - Bulgaria
        this.countryEn = obj.countryEn || ''; // default data - Bulgaria
        this.cityName = obj.cityName || '';
        this.areaOfAppeal = new AreaOfAppeal(obj.areaOfAppeal || {});
    }
}

export class BankAccount {
    constructor(obj = {}) {
        this.uid = '';
        this.id = obj.id || '';
        this.bankName = obj.bankName || '';
        this.bic = obj.bic || '';
        this.iban = obj.iban || '';
        this.description = obj.description || '';
    }
}

export class OrganizerActivity {
    constructor(obj = {}) {
        this.uid = '';
        this.id = obj.id || 0;
        this.name = obj.name || '';
        this.date = obj.date || new Date();
        this.eventTypeId = obj.eventTypeId || 0;
        this.partnershipFormId = obj.partnershipFormId || 0;
        this.finParticipationTypeId = obj.finParticipationTypeId || 0;
        this.description = obj.description || '';
    }
}

export class Company {
    constructor(obj = {}, removableManager = false, removableContact = false) {
        this.id = obj.id || 0;
        this.name = obj.name || '';
        this.vatNumber = obj.vatNumber || '';
        this.bulstatUic = obj.bulstatUic || '';
        this.phone = obj.phone || '';
        this.fax = obj.fax || '';
        this.url = obj.url || '';
        this.email = obj.email || '';
        this.description = obj.description || '';
        this.manager = obj.manager ? new Person(obj.manager) : !removableManager ? new Person({}) : null;
        this.contact = obj.contact ? new Person(obj.contact) : !removableContact ? new Person({}) : null;
        this.registeredAddress = new Address(obj.registeredAddress || {});
        this.contactAddress = new Address(obj.contactAddress || {});
        this.bankAccount = new BankAccount(obj.bankAccount || {});
    }
}

export class CompanyDetails {
    constructor(obj = {}) {
        this.id = obj.id || 0;
        this.name = obj.name || '';
        this.vatNumber = obj.vatNumber || '';
        this.bulstatUic = obj.bulstatUic || '';
        this.phone = obj.phone || '';
        this.fax = obj.fax || '';
        this.url = obj.url || '';
        this.email = obj.email || '';
        this.description = obj.description || '';
        this.manager = new ContactPerson(obj.manager || {});
        this.contact = new ContactPerson(obj.contact || {});
        this.registeredAddress = new AddressDetails(obj.registeredAddress || {});
        this.contactAddress = new AddressDetails(obj.contactAddress || {});
        this.bankAccount = new BankAccount(obj.bankAccount || {});
    }
}

export class CompanySearchModel {
    constructor(obj = {}) {
        this.id = obj.id || '';
        this.name = obj.name || '';
        this.vatNumber = obj.vatNumber || '';
        this.bulstatUic = obj.bulstatUic || '';
    }
}

export class Organizer {
    constructor(obj = {}, removableManager = false, removableContact = false) {
        this.id = obj.id || 0;
        this.name = obj.name || '';
        this.deactivated = obj.deactivated || false;
        this.description = obj.description || '';
        this.company = new Company(obj.company || {}, removableManager, removableContact);
        this.contracts = obj.contracts || [];
        this.organizerActivities = obj.organizerActivities || [];
        this.otherFields = new OtherFields(obj.otherFields || {});
        this.deletedDocumentsIds = [];
        this.documents = [];
        if (obj.documents) {
            obj.documents.forEach(doc => {
                this.documents.push(new FileDetails(doc));
            });
        }
        if (obj.files) {
            this.files = [];
            for (let i = 0; i < obj.files.length; i++) {
                this.files.push(new File(obj.files[i]));
            }
        } else {
            this.files = [];
        }

        this.auxRegisterEntityId = obj.auxRegisterEntityId || '';
    }
}

export class OrganizerDetails {
    constructor(obj = {}) {
        this.id = obj.id || 0;
        this.name = obj.name || '';
        this.deactivated = obj.deactivated || false;
        this.description = obj.description || '';
        this.company = new CompanyDetails(obj.company || {});
        this.contracts = obj.contracts || [];
        this.organizerActivities = obj.organizerActivities || [];
        this.otherFields = new OtherFields(obj.otherFields || {});
        this.documents = [];
        if (obj.documents) {
            obj.documents.forEach(doc => {
                this.documents.push(new FileDetails(doc));
            });
        }
        this.auxRegisterEntityId = obj.auxRegisterEntityId || '';
    }
}

export class Contract {
    constructor(obj = {}) {
        this.uid = obj.uid || '';
        this.id = obj.id || 0;
        this.number = obj.number || '';
        this.amount = obj.amount || '';
        this.name = obj.name || '';
        this.subject = obj.subject || '';
        this.validFromUtc = obj.validFromUtc || new Date();
        this.validToUtc = obj.validToUtc || new Date();
        this.conclusionDate = obj.conclusionDate ? new Date(obj.conclusionDate) : null;
        this.creationDateUtc = obj.creationDateUtc || new Date();
        this.description = obj.description || '';
        this.creatorId = obj.creatorId || '';
        this.tariffs = obj.tariffs || [];
    }
}

export class ContractDetails {
    constructor(obj = {}) {
        this.uid = obj.uid || '';
        this.id = obj.id || 0;
        this.number = obj.number || '';
        this.amount = obj.amount || '';
        this.name = obj.name || '';
        this.subject = obj.subject || '';
        this.validFromUtc = obj.validFromUtc || new Date();
        this.validToUtc = obj.validToUtc || new Date();
        this.conclusionDate = obj.conclusionDate ? new Date(obj.conclusionDate) : null;
        this.description = obj.description || '';
        this.tariffs = obj.tariffs || [];
        this.active = obj.active || false;
    }
}

export class ForeignLanguageModel {
    constructor(obj = {}) {
        this.languageId = obj.languageId || '';
        this.fluencyLevelByEEPId = obj.fluencyLevelByEEPId || '';
        this.fluencyLevelBySelfAssessment = obj.fluencyLevelBySelfAssessment || '';
    }
}

export class Participant {
    constructor(obj = {}) {
        this.id = obj.id || '';
        this.person = new Person(obj.person || {});
        this.bankAccount = new BankAccount(obj.bankAccount || {});
        this.participationTypeId = obj.participationTypeId || '';
        this.relationTypeId = obj.relationTypeId || '';
        this.reasonForAdmissionId = obj.reasonForAdmissionId || '';
        this.statusId = obj.statusId || '';
        this.entryId = obj.entryId || null;
        this.registerId = obj.registerId || null;
        this.note = obj.note || '';
        this.tempFileIds = obj.tempFileIds || [];
        this.eventName = obj.eventName || '';
        this.isMigrant = obj.isMigrant || false;
        this.isForeigner = obj.isForeigner || false;
        this.isMemberOfAMinority = obj.isMemberOfAMinority || false;
        this.isOfGypsyOrigin = obj.isOfGypsyOrigin || false;
        this.withDisabilities = obj.withDisabilities || false;
        this.isHomeless = obj.isHomeless || false;
        this.isDisadvantaged = obj.isDisadvantaged || false;
        this.isFromUnemployedHousehold = obj.isFromUnemployedHousehold || false;
        this.withDependentChildren = obj.withDependentChildren || false;
        this.fromOneMemberHousehold = obj.fromOneMemberHousehold || false;
        this.consentToBeProcessed = obj.consentToBeProcessed || false;
        this.deployed = obj.deployed || '';
        this.cityOfCurrentAddress = obj.cityOfCurrentAddress || '';
        this.currentSettlementId = obj.currentSettlementId || '';
        this.accommodationRequest = obj.accommodationRequest || '';
        this.datesForNights = obj.datesForNights || '';
        this.roomType = obj.roomType || '';
        this.travelers = obj.travelers || false;
        this.vegetarianMenu = obj.vegetarianMenu || false;
        this.employmentId = obj.employmentId || '';
        this.updatePersonFromParticipant = obj.updatePersonFromParticipant || false;
        this.deletedAttachedFilesId = [];
        this.isManuallyAdded = obj.isManuallyAdded || false;

        if (obj.attachedFiles) {
            this.attachedFiles = [];
            for (let i = 0; i < obj.attachedFiles.length; i++) {
                this.attachedFiles.push(new FileDetails(obj.attachedFiles[i]));
            }
        } else {
            this.attachedFiles = [];
        }

        // details
        this.participationTypeName = obj.participationTypeName || '';
        this.participationTypeNameEn = obj.participationTypeNameEn || '';
        this.relationTypeName = obj.relationTypeName || '';
        this.relationTypeNameEn = obj.relationTypeNameEn || '';
        this.reasonForAdmission = obj.reasonForAdmission || '';
        this.reasonForAdmissionEn = obj.reasonForAdmissionEn || '';
        this.status = obj.status || '';
        this.statusEn = obj.statusEn || '';
        this.employment = obj.employment || '';
        this.employmentEn = obj.employmentEn || '';
        this.currentSettlement = obj.currentSettlement || '';
        this.currentSettlementEn = obj.currentSettlementEn || '';

        this.creatorUsername = obj.creatorUsername || '';
        this.createdAtUtc = obj.createdAtUtc ? obj.createdAtUtc : null;
        this.updaterUsername = obj.updaterUsername || '';
        this.updatedAtUtc = obj.updatedAtUtc ? obj.updatedAtUtc : null;
    }
}

export class ParticipantsUpdateModel {
    constructor(obj = {}) {
        this.registerEntityToPersonIds = obj.registerEntityToPersonIds || [];
        this.participantNames = obj.participantNames || [];
        this.participationTypeId = obj.ParticipationTypeId || '';
        this.statusId = obj.statusId || '';
        this.note = obj.note || '';
        this.registerEntityId = obj.registerEntityId || '';
        this.reasonForAdmissionId = obj.reasonForAdmissionId || '';
        this.positionId = obj.positionId || '';
        this.positionStatisticId = obj.positionStatisticId || '';
        this.educationDegreeId = obj.educationDegreeId || '';
        this.institutionRegisterId = obj.institutionRegisterId || '';
        this.modalTitle = obj.modalTitle || '';
        this.editParticipationType = obj.editParticipationType || false;
        this.editRelationType = obj.editRelationType || false;
        this.editStatus = obj.editStatus || false;
        this.editReasonForAdmission = obj.editReasonForAdmission || false;
        this.editNote = obj.editNote || false;
        this.editPosition = obj.editPosition || false;
        this.editPositionStatistic = obj.editPositionStatistic || false;
        this.editEducationDegree = obj.editEducationDegree || false;
        this.editInstitutionRegister = obj.editInstitutionRegister || false;
    }
}

export class DynamicComponentBase {
    constructor(obj = {}) {
        this.name = obj.name || '';
        this.label = obj.label || '';
        this.sort = obj.sort || 0; // TODO:
        this.isRequired = obj.isRequired || false;
    }
}

export class DynamicInputModel extends DynamicComponentBase {
    constructor(obj = {}) {
        super(obj);
        this.value = obj.value || '';
    }
}

export class PlaceDetails {
    constructor(obj = {}) {
        this.name = obj.name || '';
        this.address = new AddressDetails(obj.address || {});
        this.contactPerson = obj.contactPerson ? new PersonDetails(obj.contactPerson || {}) : null
        this.otherFields = new OtherFields(obj.otherFields || {});
        this.auxRegisterEntityId = obj.auxRegisterEntityId || '';
        if (obj.halls) {
            this.halls = [];
            for (let i = 0; i < obj.halls.length; i++) {
                this.halls.push(new Hall(obj.halls[i]));
            }
        } else {
            this.halls = [];
        }
    }
}

export class Place {
    constructor(obj = {}) {
        this.id = obj.id || '';
        this.name = obj.name || '';
        this.address = new Address(obj.address || {});
        this.otherFields = new OtherFields(obj.otherFields || {});
        this.deletedHallsId = obj.deletedHallsId || [];
        this.auxRegisterEntityId = obj.auxRegisterEntityId || '';
        this.contactPerson = obj.contactPerson ? new Person(obj.contactPerson || {}) : null
        if (obj.halls) {
            this.halls = [];
            for (let i = 0; i < obj.halls.length; i++) {
                this.halls.push(new Hall(obj.halls[i]));
            }
        } else {
            this.halls = [];
        }
    }
}

export class Activity {
    constructor(obj = {}) {
        this.id = obj.id || 0;
        this.activityId = obj.activityId || 0;
        this.name = obj.name || '';
        this.typeId = obj.typeId || '';
        this.subType1Id = obj.subType1Id || '';
        this.subType2Id = obj.subType2Id || '';
        this.subType3Id = obj.subType3Id || '';
        this.auxRegisterEntityId = obj.auxRegisterEntityId || '';
    }
}

export class ActivityDetails {
    constructor(obj = {}) {
        this.id = obj.id || 0;
        this.activity = obj.activity || '';
        this.type = obj.type || '';
        this.subType1 = obj.subType1 || '';
        this.subType2 = obj.subType2 || '';
        this.subType3 = obj.subType3 || '';
        this.auxRegisterEntityId = obj.auxRegisterEntityId || '';
    }
}

export class Institution {
    constructor(obj = {}, removableManager = false, removableContact = false) {
        this.id = obj.id || 0;
        this.typeId = obj.typeId || '';
        this.name = obj.name || '';
        this.protocol = obj.protocol || '';
        this.levelId = obj.levelId || '';
        this.appellateRegionId = obj.appellateRegionId || '';
        this.realMagistratesCount = obj.realMagistratesCount || '';
        this.realEmployeesCount = obj.realEmployeesCount || '';
        this.formalMagistratesCount = obj.formalMagistratesCount || '';
        this.formalEmployeesCount = obj.formalEmployeesCount || '';
        this.totalFormalCount = obj.totalFormalCount || '';
        this.otherFields = new OtherFields(obj.otherFields || {});
        this.company = new Company(obj.company || {}, removableManager, removableContact);
        this.companyId = this.company.id || 0;
        this.stateGazette = obj.stateGazette || '';
        this.auxRegisterEntityId = obj.auxRegisterEntityId || '';
    }
}

export class InstitutionDetails {
    constructor(obj = {}) {
        this.id = obj.id || 0;
        this.type = obj.typeId || '';
        this.name = obj.name || '';
        this.protocol = obj.protocol || '';
        this.level = obj.level || '';
        this.appellateRegion = obj.appellateRegion || '';
        this.realMagistratesCount = obj.realMagistratesCount || '';
        this.realEmployeesCount = obj.realEmployeesCount || '';
        this.formalMagistratesCount = obj.formalMagistratesCount || '';
        this.formalEmployeesCount = obj.formalEmployeesCount || '';
        this.totalFormalCount = obj.totalFormalCount || '';
        this.otherFields = new OtherFields(obj.otherFields || {});
        this.company = new CompanyDetails(obj.company || {});
        this.stateGazette = obj.stateGazette || '';
        this.auxRegisterEntityId = obj.auxRegisterEntityId || '';
    }
}

export class ExternalSupplier {
    constructor(obj = {}) {
        this.id = obj.id || 0;
        this.deactivated = obj.deactivated || false;
        this.company = obj.company ? new Company(obj.company || {}) : null;
        this.person = obj.person ? new Person(obj.person || {}) : null;
        this.isCompany = obj.isCompany || false;
        this.otherFields = new OtherFields(obj.otherFields || {});
        this.auxRegisterEntityId = obj.auxRegisterEntityId || '';
        this.deletedContacts = [];
        this.deletedContracts = [];
        this.contacts = [];
        this.contracts = [];
        this.documents = [];
        this.files = [];
        this.deletedDocumentsIds = [];
        if (obj.contracts) {
            for (let index = 0; index < obj.contracts.length; index++) {
                this.contracts.push(new Contract(obj.contracts[index]));
            }
        }
        if (obj.contacts) {
            for (let index = 0; index < obj.contacts.length; index++) {
                this.contacts.push(new Person(obj.contacts[index]));
            }
        }
        if (obj.documents) {
            obj.documents.forEach(doc => {
                this.documents.push(new FileDetails(doc));
            });
        }
        if (obj.files) {
            for (let i = 0; i < obj.files.length; i++) {
                this.files.push(new File(obj.files[i]));
            }
        }
    }
}


export class ExternalSupplierDetails {
    constructor(obj = {}) {
        this.id = obj.id || 0;
        this.deactivated = obj.deactivated || false;
        this.company = obj.company ? new CompanyDetails(obj.company || {}) : null;
        this.person = obj.person ? new PersonDetails(obj.person || {}) : null;
        this.isCompany = obj.isCompany || false;
        this.otherFields = new OtherFields(obj.otherFields || {});
        this.auxRegisterEntityId = obj.auxRegisterEntityId || '';
        this.contacts = [];
        this.contracts = [];
        this.documents = [];
        if (obj.contracts) {
            for (let index = 0; index < obj.contracts.length; index++) {
                this.contracts.push(new ExternalSupplierContractDetails(obj.contracts[index]));
            }
        }
        if (obj.contacts) {
            for (let index = 0; index < obj.contacts.length; index++) {
                this.contacts.push(new ContactPerson(obj.contacts[index]));
            }
        }
        if (obj.documents) {
            obj.documents.forEach(doc => {
                this.documents.push(new FileDetails(doc));
            });
        }
    }
}

export class ExternalSupplierContractDetails extends ContractDetails {
    constructor(obj = {}) {
        super(obj);
        this.tariffs = [];
        if (obj.tariffs) {
            for (let i = 0; i < obj.tariffs.length; i++) {
                this.tariffs.push(new TariffEntity(obj.tariffs[i]));
            }
        }
    }
}

export class Employee {
    constructor(obj = {}) {
        this.id = obj.id || '';
        this.person = new Person(obj.person || {});
        this.managerId = obj.managerId || '';
        this.directorateId = obj.directorateId || '';
        this.administrativePositionId = obj.administrativePositionId || '';
        // this.workAddress = new Address(obj.workAddress || {});
        this.workPhone = obj.workPhone || '';
        this.activityЕvaluations = [];
        this.auxRegisterEntityId = obj.auxRegisterEntityId || '';
        this.leavingDate = obj.leavingDate;

        if (obj.activityЕvaluations) {
            obj.activityЕvaluations.forEach(item => this.activityЕvaluations.push(new ActivityЕvaluation(item)));
        }
    }
}

export class ActivityЕvaluation {
    constructor(obj = {}) {
        // eslint-disable-next-line symbol-description
        this._id = Symbol();
        this.id = obj.id || 0;
        this.year = obj.year || null;
        this.evaluation = obj.evaluation || null;
        this.attachment = new File(obj.attachment || {});
        this.isDeleted = false;
    }
}

export class EmployeeDetails {
    constructor(obj = {}) {
        this.id = obj.id || '';
        this.person = new PersonDetails(obj.person || {});
        this.manager = obj.manager || '';
        this.directorate = obj.directorate || '';
        this.workAddress = new AddressDetails(obj.workAddress || {});
        this.workPhone = obj.workPhone || '';
        // this.workPlace = obj.workPlace || '';
        this.administrativePosition = obj.administrativePosition || '';
        this.activityЕvaluations = [];
        this.auxRegisterEntityId = obj.auxRegisterEntityId || '';
        this.leavingDate = obj.leavingDate;

        if (obj.activityЕvaluations) {
            obj.activityЕvaluations.forEach(item => this.activityЕvaluations.push(new ActivityЕvaluation(item)));
        }
    }
}

export class AdministrativePositionSubstitutions {
    constructor(obj = {}) {
        this.id = obj.id || 0;
        this.replacementId = obj.replacementId || '';
        this.replacedId = obj.replacedId || '';
        this.replacement = obj.replacement || '';
    }
}

export class AdministrativePosition {
    constructor(obj = {}) {
        this.id = obj.id || 0;
        this.name = obj.name || '';
        this.department = obj.department || '';
        this.directorate = obj.directorate || '';
        this.contactDetails = obj.contactDetails || '';
        this.location = obj.location || '';
        this.otherFields = new OtherFields(obj.otherFields || {});
        this.auxRegisterEntityId = obj.auxRegisterEntityId || '';
        this.deletedIds = [];
        this.replacements = [];
        this.managerPositionId = obj.managerPositionId || '';
        if (obj.replacements) {
            for (let i = 0; i < obj.replacements.length; i++) {
                this.replacements.push(new AdministrativePositionSubstitutions(obj.replacements[i]));
            }
        }
    }
}

export class AdministrativePositionDetails {
    constructor(obj = {}) {
        this.id = obj.id || 0;
        this.name = obj.name || '';
        this.departmentName = obj.departmentName || '';
        this.directorateName = obj.directorateName || '';
        this.contactDetails = obj.contactDetails || '';
        this.location = obj.location || '';
        this.otherFields = new OtherFields(obj.otherFields || {});
        this.auxRegisterEntityId = obj.auxRegisterEntityId || '';
        this.replacements = [];
        this.managerPosition = obj.managerPosition || '';
        if (obj.replacements) {
            for (let i = 0; i < obj.replacements.length; i++) {
                this.replacements.push(new AdministrativePositionSubstitutions(obj.replacements[i]));
            }
        }
    }
}

export class OrganizerContracts {
    constructor(obj = {}) {
        this.id = obj.id || 0;
        this.organizerId = obj.organizerId || 0;
        this.organizerContractId = obj.organizerContractId || 0;
        this.organizerContract = new Contract(obj.contract || {});
    }
}

export class OrganizerContractsDetails {
    constructor(obj = {}) {
        this.id = obj.id || 0;
        this.organizer = obj.organizer || '';
        this.organizerContract = obj.organizerContract || '';
    }
}

export class Project {
    constructor(obj = {}) {
        this.id = obj.id || 0;
        this.number = obj.id || 0;
        this.name = obj.name || '';
        this.contract = obj.contract || '';
        this.fundingTypeId = obj.fundingTypeId || '';
        this.otherFields = new OtherFields(obj.otherFields || {});
        this.projectActivities = obj.projectActivities || [];
        this.auxRegisterEntityId = obj.auxRegisterEntityId || '';

        if (obj.organizers) {
            this.organizers = [];
            for (let i = 0; i < obj.organizers.length; i++) {
                this.organizers.push(new OrganizerContracts(obj.organizers[i]));
            }
        } else {
            this.organizers = [];
        }

        if (obj.activities) {
            this.activities = [];
            for (let i = 0; i < obj.activities.length; i++) {
                this.activities.push(new Activity(obj.activities[i]));
            }
        } else {
            this.activities = [];
        }
    }
}

export class ProjectDetails {
    constructor(obj = {}) {
        this.id = obj.id || 0;
        this.number = obj.id || 0;
        this.name = obj.name || '';
        this.contract = obj.contract || '';
        this.fundingType = obj.fundingType || '';
        this.otherFields = new OtherFields(obj.otherFields || {});
        this.activity = obj.activity || '';
        this.projectActivities = obj.projectActivities || [];
        this.auxRegisterEntityId = obj.auxRegisterEntityId || '';

        if (obj.organizers) {
            this.organizers = [];
            for (let i = 0; i < obj.organizers.length; i++) {
                this.organizers.push(new OrganizerContractsDetails(obj.organizers[i]));
            }
        } else {
            this.organizers = [];
        }
        if (obj.activities) {
            this.activities = [];
            for (var i = 0; i < obj.activities.length; i++) {
                this.activities.push(new ActivityDetails(obj.activities[i]));
            }
        } else {
            this.activities = [];
        }
    }
}

export class PublicOrder {
    constructor(obj = {}) {
        this.id = obj.id || 0;
        this.publicOrdersCurrentNumber = obj.publicOrdersCurrentNumber || '';
        this.currentNumberNIP = obj.currentNumberNIP || '';
        this.itemName = obj.itemName || '';
        this.publishDate = obj.publishDate || '';
        this.isOpen = obj.isOpen || false;
        this.orderTypeId = obj.orderTypeId || '';
        this.statusId = obj.statusId || '';
        this.typeOfOrderTypeId = obj.typeOfOrderTypeId || '';
        this.description = obj.description || '';
        this.termDate = obj.termDate || '';
        this.objectTypeId = obj.objectTypeId || '';
        this.referenceValue = obj.referenceValue || '';
        this.fileNumber = obj.fileNumber || '';
        this.referenceValueCurrencyId = obj.referenceValueCurrencyId || '';
        this.otherFields = new OtherFields(obj.otherFields || {});
        this.contactPerson = new Person(obj.contactPerson || {});
        this.referenceOrderId = obj.referenceOrderId || '';
        this.activityId = obj.activityId || '';
        this.auxRegisterEntityId = obj.auxRegisterEntityId || '';
        this.deletedDocumentsIds = [];
        this.deletedContactsIds = [];
        this.documents = [];
        this.contacts = [];
        this.publicOrderToContactModels = [];
        this.files = [];
        if (obj.publicOrderToContactModels) {
            obj.publicOrderToContactModels.forEach(contact => {
                this.publicOrderToContactModels.push({
                    id: contact.id,
                    name: contact.name,
                    email: contact.email,
                    phoneWork: contact.phoneWork,
                    phonePrivate: contact.phonePrivate
                });
            })
        }
        if (obj.documents) {
            obj.documents.forEach(doc => {
                this.documents.push(new FileDetails(doc));
            });
        }
        if (obj.files) {
            for (let i = 0; i < obj.files.length; i++) {
                this.files.push(new File(obj.files[i]));
            }
        }
    }
}

export class PublicOrderStatusChange {
    constructor(obj = {}) {
        this.id = obj.id || '';
        this.publicOrderId = obj.publicOrderId || '';
        this.previousStatusId = obj.previousStatusId || '';
        this.previousStatus = obj.previousStatus || '';
        this.currentStatusId = obj.currentStatusId || '';
        this.currentStatus = obj.currentStatus || '';
        this.updateTimeUtc = obj.updateTimeUtc || '';
        this.user = obj.user || '';
    }
}

export class PublicOrderDetails {
    constructor(obj = {}) {
        this.id = obj.id || 0;
        this.publicOrdersCurrentNumber = obj.publicOrdersCurrentNumber || '';
        this.currentNumberNIP = obj.currentNumberNIP || '';
        this.itemName = obj.itemName || '';
        this.publishDate = obj.publishDate || '';
        this.isOpen = obj.isOpen || false;
        this.orderType = obj.orderType || '';
        this.status = obj.status || '';
        this.statusId = obj.statusId || 0;
        this.typeOfOrderType = obj.typeOfOrderType || '';
        this.description = obj.description || '';
        this.termDate = obj.termDate || '';
        this.objectType = obj.objectType || '';
        this.referenceValue = obj.referenceValue || 0;
        this.fileNumber = obj.fileNumber || '';
        this.referenceValueCurrency = obj.referenceValueCurrency || '';
        this.referenceOrder = obj.referenceOrder || '';
        this.activity = obj.activity || '';
        this.auxRegisterEntityId = obj.auxRegisterEntityId || '';
        this.otherFields = new OtherFields(obj.otherFields || {});
        this.publicOrderToContactModels = [];
        if (obj.publicOrderToContactModels) {
            obj.publicOrderToContactModels.forEach(contact => {
                this.publicOrderToContactModels.push({
                    id: contact.id,
                    name: contact.name,
                    email: contact.email,
                    phoneWork: contact.phoneWork,
                    phonePrivate: contact.phonePrivate
                });
            })
        }
        this.documents = [];
        if (obj.documents) {
            obj.documents.forEach(doc => {
                this.documents.push(new FileDetails(doc));
            });
        }
        this.statusChanges = [];
        if (obj.statusChanges) {
            obj.statusChanges.forEach(status => {
                this.statusChanges.push(new PublicOrderStatusChange(status));
            })
        }
    }
}


export class ThematicArea {
    constructor(obj = {}) {
        this.id = obj.id || '';
        this.name = obj.name || '';
        this.legalAreaId = obj.legalAreaId || '';
        this.lectorId = obj.lectorId || '';
        this.auxRegisterEntityId = obj.auxRegisterEntityId || '';
        this.otherFields = new OtherFields(obj.otherFields || {});
    }
}

export class ThematicAreaDetails {
    constructor(obj = {}) {
        this.name = obj.name || '';
        this.legalArea = obj.legalArea || '';
        this.auxRegisterEntityId = obj.auxRegisterEntityId || '';
        this.otherFields = new OtherFields(obj.otherFields || {});
        this.lecturers = [];
        if (obj.lecturers) {
            obj.lecturers.forEach(lector => {
                this.lecturers.push(new LectorToThematicArea(lector));
            })
        }
    }
}

export class Accommodation {
    constructor(obj = {}) {
        this.single = obj.single || '';
        this.double = obj.double || '';
        this.triple = obj.triple || '';
        this.apartment = obj.apartment || '';
        this.food = obj.food || false;
        this.menuTypeIds = obj.menuTypeIds || [];
    }
}

export class AccommodationDetails {
    constructor(obj = {}) {
        this.single = obj.single || '';
        this.double = obj.double || '';
        this.triple = obj.triple || '';
        this.apartment = obj.apartment || '';
        this.food = obj.food || false;
        this.menuTypes = obj.menuTypes || [];
    }
}

export class AccommodationPlace {
    constructor(obj = {}) {
        this.id = obj.id || 0;
        this.name = obj.name || '';
        this.auxRegisterEntityId = obj.auxRegisterEntityId || '';
        this.address = new Address(obj.address || {});
        this.accommodation = new Accommodation(obj.accommodation || {});
        this.nameEn = obj.nameEn;
        this.typeId = obj.typeId;
        this.categoryId = obj.categoryId;
        this.url = obj.url;
        this.otherFields = new OtherFields(obj.otherFields || {});
        if (obj.contact) {
            this.contact = new Person(obj.contact || {});
        } else {
            this.contact = null
        }
    }
}

export class AccommodationPlaceDetails {
    constructor(obj = {}) {
        this.id = obj.id || 0;
        this.name = obj.name || '';
        this.auxRegisterEntityId = obj.auxRegisterEntityId || '';
        this.address = new AddressDetails(obj.address || {});
        this.contact = new PersonDetails(obj.contact || {});
        this.accommodation = new AccommodationDetails(obj.accommodation || {});
        this.nameEn = obj.nameEn;
        this.type = obj.type;
        this.category = obj.category;
        this.url = obj.url;
        this.otherFields = new OtherFields(obj.otherFields || {});
    }
}

export class Hall {
    constructor(obj = {}) {
        this.id = obj.id || '';
        this.name = obj.name || '';
        this.capacity = obj.capacity || 0;
    }
}

export class EditorComponentModel {
    constructor(obj = {}) {
        this.id = obj.id || '';
        this.uid = obj.uid || '';
        this.name = obj.name || '';
        this.nameEn = obj.nameEn || '';
        this.fieldType = obj.fieldType || '';
        this.inputType = obj.inputType || 'text'; // text / number for Input
        this.label = obj.label || '';
        this.labelEn = obj.labelEn || '';
        this.size = obj.size || '';
        this.sort = obj.sort || 0;
        this.description = obj.description || '';
        this.descriptionEn = obj.descriptionEn || '';

        // Constraints
        this.isRequired = obj.isRequired || false;
        this.isUnique = obj.isUnique || false;
        this.isReadOnly = obj.isReadOnly || false;
        this.showInDescription = obj.showInDescription || false;

        this.numberType = obj.numberType || '';

        this.intMinValue = obj.intMinValue || 0;
        this.intMaxValue = obj.intMaxValue || 1;
        this.intDefaultValue = obj.intDefaultValue || 0;

        this.decimalMinValue = obj.decimalMinValue || 0;
        this.decimalMaxValue = obj.decimalMaxValue || 1;
        this.decimalDefaultValue = obj.decimalDefaultValue || 0;
        this.decimalPrecision = obj.decimalPrecision || 2;

        this.numberFormat = obj.numberFormat || '';
        this.numberType = obj.numberType || '';

        this.textMinLength = obj.textMinLength || 1;
        this.textMaxLength = obj.textMaxLength || 1000;
        this.textDefaultValue = obj.textDefaultValue || '';
        this.textAllowNullOrEmpty = obj.textAllowNullOrEmpty || true;

        this.datetimeMinValue = obj.datetimeMinValue || '';
        this.datetimeMaxValue = obj.datetimeMaxValue || '';
        this.datetimeDefaultValue = obj.datetimeDefaultValue || '';
        this.datetimeFormat = obj.datetimeFormat || '';

        this.booleanDefaultValue = obj.booleanDefaultValue || false;

        // Dropdown
        this.isMultiDropdown = obj.isMultiDropdown || false;
        this.dropdownIsCity = obj.dropdownIsCity || false;
        this.dropdownType = obj.dropdownType || '';
        this.dropdownId = obj.dropdownId || '';
        this.dropdownDisplayMember = obj.dropdownDisplayMember || '';

        this.fieldValue = new DynamicRegisterFieldValueModel(obj.fieldValue || {});

        // Locked for edit
        this.locked = obj.locked || false;
        this.fieldCode = obj.fieldCode || '';
        this.isTemplate = obj.isTemplate || false;

        // Regex validation
        this.regexValidation = obj.regexValidation || '';
        this.validationError = obj.validationError || '';
        this.validationErrorEn = obj.validationErrorEn || '';

        this.isEvaluationPanel = obj.isEvaluationPanel;
    }
}

export class EditorPanel {
    constructor(obj = {}) {
        this.id = obj.id || '';
        this.sort = obj.sort || 1;
        this.name = obj.name || '';
        this.nameEn = obj.nameEn || '';
        this.label = obj.label || '';
        this.labelEn = obj.labelEn || '';
        this.locked = obj.locked || false;
        this.uid = obj.uid || '';
        this.isEvaluationPanel = obj.isEvaluationPanel || false;
        this.participationTypeId = obj.participationTypeId || '';
        this.registerEntityToPersonId = obj.registerEntityToPersonId || '';

        this.components = [];
        if (obj.components) {
            obj.components.forEach(component => {
                this.components.push(new EditorComponentModel(component));
            });
        }
    }
}

export class EditorRegister {
    constructor(obj = {}) {
        this.id = obj.id || '';
        this.name = obj.name || '';
        this.nameEn = obj.nameEn || '';
        this.registerTypeId = obj.registerTypeId || 1; // TODO: Add enum
        this.registerEntryId = obj.registerEntryId || '';
        this.deleted = obj.deleted;

        this.panels = [];
        if (obj.panels) {
            obj.panels.forEach(panel => {
                this.panels.push(new EditorPanel(panel));
            });
        }

        this.files = [];
        if (obj.files) {
            obj.files.forEach(file => {
                this.files.push(new File(file));
            });
        }

        this.registerEntityExtension = new RegisterEntityExtension(obj.registerEntityExtension);
    }
}

export class RegisterEntityExtension {
    constructor(obj = {}) {
        this.registerEntityId = obj.registerEntityId || 0;
        this.participantsMaxNum = obj.participantsMaxNum || 0;
        this.excludeFromReporting = obj.excludeFromReporting || false;
        this.isEvent = obj.isEvent || false;
        this.syncedWithMoodle = obj.syncedWithMoodle || false;
        this.moodleSyncResult = obj.moodleSyncResult || '';
        this.moodleEventLink = obj.moodleEventLink || ''
        this.isPublic = obj.isPublic || false;
        this.isLockedForEdit = obj.isLockedForEdit || false;
        this.useExtSubscriptionService = obj.useExtSubscriptionService || false;
        this.extSubscriptionService = obj.extSubscriptionService || '';
        this.statusId = obj.statusId || '';
        this.syncPrivateEventsWithMoodle = obj.syncPrivateEventsWithMoodle || false;
        this.certificateDefaultReportId = obj.certificateDefaultReportId || '';
        this.lecturerCertificateDefaultReportId = obj.lecturerCertificateDefaultReportId || '';
        this.eventTypeId = obj.eventTypeId || '';
        this.moduleName = obj.moduleName || '';
        this.isMainEventModule = obj.isMainEventModule || false;
        this.isModuleEvent = obj.isModuleEvent || false;
    }
}

export class DynamicRegisterModel {
    constructor(obj = {}) {
        this.fieldValues = obj.fieldValues || [];
        this.people = obj.people || [];
        this.addresses = obj.addresses || [];
        this.registerName = obj.registerName || '';
        this.relatedForms = obj.relatedForms || [];
        this.formToRegisterEntityId = obj.formToRegisterEntityId || 0;
        this.registerEntityExtension = obj.registerEntityExtension || {};
        this.savedFilesToDeleteIds = obj.savedFilesToDeleteIds || [];
        this.isNew = obj.isNew || false;
    }
}

export class EditorForms {
    constructor(obj = {}) {
        this.id = obj.id || '';
        this.name = obj.name || '';
        this.nameEn = obj.nameEn || '';
        this.eventRegisterEntityId = obj.eventRegisterEntityId || '';
        this.formTypeId = obj.formTypeId || ''; // TODO: Add enum
        this.registerEntityId = obj.registerEntityId || 0;
        this.registerFieldValueId = obj.registerFieldValueId || '';
        this.registerEntities = obj.registerEntities || [];
        this.validFromUtc = obj.validFromUtc || new Date();
        this.validToUtc = obj.validToUtc || new Date();
        this.deactivated = obj.deactivated || false;
        this.note = obj.note || '';
        this.isTemplate = obj.isTemplate || false;
        this.allowAnonymous = obj.allowAnonymous || false;
        this.header = obj.header || '';
        this.footer = obj.footer || '';

        this.panels = [];
        if (obj.panels) {
            obj.panels.forEach(panel => {
                this.panels.push(new EditorPanel(panel));
            });
        }

        this.files = [];
        if (obj.files) {
            obj.files.forEach(file => {
                this.files.push(new File(file));
            });
        }
    }
}

export class DynamicRegisterFieldValueModel {
    constructor(obj = {}) {
        this.id = obj.id || '';
        this.uid = obj.uid || '';
        this.registerEntryId = obj.registerEntryId || '';
        this.registerFieldId = obj.registerFieldId || '';
        this.intValue = obj.intValue || '';
        this.decimalValue = obj.decimalValue || '';
        this.textValue = obj.textValue || '';
        this.datetimeValue = obj.datetimeValue || '';
        this.booleanValue = obj.booleanValue || '';
        this.label = obj.label || '';
        this.labelEn = obj.labelEn || '';
        this.name = obj.name || '';
        this.nameEn = obj.nameEn || '';
        this.isMultiDropdown = obj.isMultiDropdown || '';
        this.updateTime = obj.updateTime ? new Date(obj.updateTime) : null
        this.files = [];

        if (obj.files) {
            obj.files.forEach(file => {
                this.files.push(new File(file));
            });
        }

        this.stringValue = obj.stringValue || '';
    }
}

export class EventsStatuses {
    constructor(obj = {}) {
        this.allEvents = obj.allEvents || 0;
        this.pastEvents = obj.pastEvents || 0;
        this.upcomingEvents = obj.upcomingEvents || 0;
        this.activeEvents = obj.activeEvents || 0;
        this.eventsWithPastEnrollment = obj.eventsWithPastEnrollment || 0;
        this.eventsWithUpcomingEnrollment = obj.eventsWithUpcomingEnrollment || 0;
        this.eventsWithActiveEnrollment = obj.eventsWithActiveEnrollment || 0;
        this.deleted = obj.deleted || 0;
        this.deactivated = obj.deactivated || 0;
        this.updated = obj.updated || 0;
    }
}

export class Role {
    constructor(obj = {}) {
        this.id = obj.id || 0;
        this.name = obj.name || '';
        this.description = obj.description || '';
        this.normalizedName = obj.normalizedName || '';
        this.deactivated = obj.deactivated || false;
    }
}

export class DynamicRegisterPersonModel {
    constructor(obj = {}) {
        this.fieldId = obj.fieldId || '';
        this.isLecturer = obj.isLecturer || false;
        this.person = obj.person;
    }
}

export class DynamicRegisterAddressModel {
    constructor(obj = {}) {
        this.fieldId = obj.fieldId || '';
        this.address = obj.address;
    }
}

export class SelectedTariffItem {
    constructor(obj = {}) {
        this.id = obj.id || 0;
        this.itemNumber = obj.itemNumber || '';
        this.groupName = obj.groupName || '';
        this.groupNameEn = obj.groupNameEn || '';
        this.name = obj.name || '';
        this.nameEn = obj.nameEn || '';
        this.description = obj.description || '';
        this.specification = obj.specification || '';
        this.package = obj.package || '';
        this.code = obj.code || '';
        this.qty = obj.qty || 0;
        this.measure = obj.measure || '';
        this.singlePrice = obj.singlePrice || 0;
        this.singlePriceWithTax = obj.singlePriceWithTax || 0;
        this.maxPrice = obj.maxPrice || 0;
        this.total = obj.total || 0.00;
        this.totalWithTax = obj.totalWithTax || 0.00;
    }
}

export class TariffEntity {
    constructor(obj = {}) {
        this.id = obj.id || 0;
        this.name = obj.name || '';
        this.nameEn = obj.nameEn || '';
        this.description = obj.description || '';
        this.contractId = obj.contractId || '';
        this.allowedEventForms = obj.allowedEventForms || [];
        this.defaultForEventForms = obj.defaultForEventForms || [];
        this.selectedItems = obj.selectedItems || {};
        this.deleted = obj.deleted || false;
        this.deactivated = obj.deactivated || false;
        this.updated = obj.updated || false;
        this.contractDisplayName = obj.contractDisplayName || '';
        this.allowedEventFormsEn = obj.allowedEventFormsEn || [];
        this.defaultForEventFormsEn = obj.allowedEventFormsEn || [];
    }
}

export class FormToEvent {
    constructor(obj = {}) {
        this.id = obj.id || 0;
        this.checked = obj.checked || false;
        this.name = obj.name || '';
        this.nameEn = obj.nameEn || '';
        this.formType = obj.formType || '';
        this.formTypeEn = obj.formTypeEn || '';

        this.note = obj.note || '';
        this.link = obj.link || '';
        this.formToRegisterEntityId = obj.formToRegisterEntityId || '';
        this.validFromUtc = obj.validFromUtc ? new Date(obj.validFromUtc) : new Date();
        this.validToUtc = obj.validFromUtc ? new Date(obj.validToUtc) : new Date().addDays(30);
    }
}

export class FormToEven {
    constructor(obj = {}) {
        this.id = obj.id || '';
        this.eventId = obj.eventId || '';
        this.formId = obj.formId || '';
        this.formType = obj.formType || '';
        this.formTypeEn = obj.formTypeEn || '';
        this.name = obj.name || '';
        this.nameEn = obj.nameEn || '';
        this.eventName = obj.eventName || '';
        this.startTime = obj.startTime ? obj.startTime : null;
        this.endTime = obj.endTime ? obj.endTime : null;
        this.deactivated = obj.deactivated || false;
        this.allowAnonymous = obj.allowAnonymous || false;
        this.isTemplate = obj.isTemplate || false;
        this.isPopulatingRequired = obj.isPopulatingRequired || false;
        this.participationTypes = obj.participationTypes || [];
        this.isAnonymous = obj.isAnonymous;
        this.isAuthorHidden = obj.isAuthorHidden || false;
        this.validRecords = obj.validRecords;
        this.isFingerprintingDisabled = obj.isFingerprintingDisabled || false;
    }
}

export class ThematicAreaProposalModel {
    constructor(obj = {}) {
        this.thematicArea = obj.thematicArea || '';
        this.legalAreaId = obj.legalAreaId || '';
    }
}

export class Lector {
    constructor(obj = {}) {
        this.id = obj.id || '';
        this.person = new Person(obj.person);
        this.thematicAreaIds = obj.thematicAreaIds || [];
        this.themesIds = obj.themesIds || [];
        this.lectorsTeaching = obj.lectorsTeaching || false;
        this.universityTeaching = obj.universityTeaching || false;
        this.nipTeaching = obj.nipTeaching || false;
        this.practitionersTeaching = obj.practitionersTeaching || false;
        // TODO: Events ids
        this.notes = obj.notes || '';
        this.lectorStatusId = obj.lectorStatusId || '';
        this.reasonForJoiningAsTeacherId = obj.reasonForJoiningAsTeacherId || '';
        this.decisionForJoining = obj.decisionForJoining || '';
        this.decisionForJoiningDate = obj.decisionForJoiningDate || '';
        this.additionalInfoForJoining = obj.additionalInfoForJoining || '';
        this.reasonForReleaseOfTeacherId = obj.reasonForReleaseOfTeacherId || '';
        this.decisionForRelease = obj.decisionForRelease || '';
        this.decisionForReleaseDate = obj.decisionForReleaseDate || '';
        this.additionalInfoForRelease = obj.additionalInfoForRelease || '';
        this.cv = new File(obj.cv || {});
        this.deletedCVid = obj.deletedCVid || '';
        this.documents = [];
        this.deletedDocumentsIds = [];
        this.livingAddress = new Address(obj.livingAddress || {});
        this.files = [];
        this.deletedContracts = [];
        if (obj.files) {
            for (let i = 0; i < obj.files.length; i++) {
                this.files.push(new File(obj.files[i]));
            }
        }
        if (obj.documents) {
            obj.documents.forEach(doc => {
                this.documents.push(new FileDetails(doc));
            });
        }
        this.cvDetails = {};
        if (obj.cvDetails) {
            this.cvDetails = new FileDetails(obj.cvDetails);
        }
        this.auxRegisterEntityId = obj.auxRegisterEntityId || '';
    }
}

export class LectorDetails {
    constructor(obj = {}) {
        this.id = obj.id || '';
        this.person = new PersonDetails(obj.person);
        this.thematicAreaIds = obj.thematicAreaIds || [];
        this.themesIds = obj.themesIds || [];
        this.lectorsTeaching = obj.lectorsTeaching || false;
        this.universityTeaching = obj.universityTeaching || false;
        this.nipTeaching = obj.nipTeaching || false;
        this.practitionersTeaching = obj.practitionersTeaching || false;
        // TODO: Events ids
        this.notes = obj.notes || '';
        this.lectorStatus = obj.lectorStatus || '';
        this.reasonForJoiningAsTeacher = obj.reasonForJoiningAsTeacher || '';
        this.decisionForJoining = obj.decisionForJoining || '';
        this.decisionForJoiningDate = obj.decisionForJoiningDate || '';
        this.additionalInfoForJoining = obj.additionalInfoForJoining || '';
        this.reasonForReleaseOfTeacher = obj.reasonForReleaseOfTeacher || '';
        this.decisionForRelease = obj.decisionForRelease || '';
        this.decisionForReleaseDate = obj.decisionForReleaseDate || '';
        this.additionalInfoForRelease = obj.additionalInfoForRelease || '';
        this.cvDetails = new FileDetails(obj.cvDetails || {});
        this.livingAddress = new AddressDetails(obj.livingAddress || {});
        this.documents = [];
        if (obj.documents) {
            obj.documents.forEach(doc => {
                this.documents.push(new FileDetails(doc));
            });
        }
        this.auxRegisterEntityId = obj.auxRegisterEntityId || '';
    }
}

export class LectorToThematicArea {
    constructor(obj = {}) {
        this.id = obj.id || '';
        this.name = obj.name || '';
    }
}

export class Mentor {
    constructor(obj = {}) {
        this.id = obj.id || '';
        this.person = new Person(obj.person || {});
        this.salutationId = obj.salutationId || '';
        // this.institutionId = obj.institutionId || '';
        this.directorateId = obj.directorateId || '';
        this.additionalInfoMentoring = obj.additionalInfoMentoring || '';
        this.startDateMentoring = obj.startDateMentoring || '';
        this.endDateMentoring = obj.endDateMentoring || '';
        this.decisionForJoiningMentor = obj.decisionForJoiningMentor || '';
        this.participants = [];
        this.participantsDetails = [];
        this.deletedParticipants = [];
        if (obj.participants) {
            obj.participants.forEach(participant => {
                this.participants.push(new Person(participant));
            })
        }
        if (obj.participantsDetails) {
            obj.participantsDetails.forEach(participantDetails => {
                this.participantsDetails.push(new PersonDetails(participantDetails));
            })
        }
        this.auxRegisterEntityId = obj.auxRegisterEntityId || '';
    }
}

export class MentorDetails {
    constructor(obj = {}) {
        this.id = obj.id || '';
        this.person = new PersonDetails(obj.person || {});
        this.salutation = obj.salutation || '';
        // this.institutionId = obj.institutionId || '';
        // this.institution = obj.institution || '';
        this.directorate = obj.directorate || '';
        this.additionalInfoMentoring = obj.additionalInfoMentoring || '';
        this.startDateMentoring = obj.startDateMentoring || '';
        this.endDateMentoring = obj.endDateMentoring || '';
        this.decisionForJoiningMentor = obj.decisionForJoiningMentor || '';
        this.participantsDetails = [];
        if (obj.participantsDetails) {
            obj.participantsDetails.forEach(participant => {
                this.participantsDetails.push(new PersonDetails(participant));
            })
        }
        this.auxRegisterEntityId = obj.auxRegisterEntityId || '';
    }
}

export class PlanningModel {
    constructor(obj = {}) {
        this.id = obj.id || '';
        this.year = obj.year || new Date().getFullYear() + 1;
        this.items = [];
        if (obj.items) {
            obj.items.forEach(item => {
                this.items.push(new PlanningItemModel(item));
            });
        }
    }
}

export class PlanningItemModel {
    constructor(obj = {}) {
        this.id = obj.id || '';
        this.includeInAnnualCatalog = obj.includeInAnnualCatalog || false;
        this.formEntryId = obj.formEntryId || '';
        this.theme = obj.theme || '';
        this.themeId = obj.themeId || '';
        this.alternativeName = obj.alternativeName || '';
        this.thematicAreaId = obj.thematicAreaId || '';
        this.legalAreaId = obj.legalAreaId || '';
        this.proposedLectorsIds = obj.proposedLectorsIds || [];
        this.lectors = obj.lectors || [];
        this.isNewAdded = obj.isNewAdded || false;

        this.loadingLectors = obj.loadingLectors || false;
        this.loadingEvents = obj.loadingEvents || false;
        this.loadingDescription = obj.loadingDescription || false;

        this.descriptionIsEvent = obj.descriptionIsEvent || false;
        this.descriptionName = obj.descriptionName || '';
        this.descriptionId = obj.descriptionId || '';

        this.eventsForTheme = [];
        if (obj.eventsForTheme) {
            obj.eventsForTheme.forEach(item => {
                this.eventsForTheme.push(new PlanningItemEventsForThemeModel(item));
            });
        }

        this.lectorsForTheme = [];
        if (obj.lectorsForTheme) {
            obj.lectorsForTheme.forEach(item => {
                this.lectorsForTheme.push(new PlanningItemLectorsForThemeModel(item));
            });
        }
    }
}

export class PlanningItemEventsForThemeModel {
    constructor(obj = {}) {
        this.id = obj.id || '';
        this.name = obj.name || '';
    }
}

export class PlanningItemLectorsForThemeModel {
    constructor(obj = {}) {
        this.id = obj.id || '';
        this.name = obj.name || '';
        this.email = obj.email || '';
    }
}

export class AnnualCatalogProjectModel {
    constructor(obj = {}) {
        this.id = obj.id;
        this.year = obj.year;
        this.hasCreatedAnnualCatalogForTheYear = obj.hasCreatedAnnualCatalogForTheYear;
        this.items = [];
        if (obj.items) {
            obj.items.forEach(item => {
                this.items.push(new AnnualCatalogProjectItemModel(item));
            });
        }
    }
}

export class AnnualCatalogProjectItemModel {
    constructor(obj = {}) {
        this.id = obj.id;
        this.includeInAnnualCatalog = obj.includeInAnnualCatalog || false;
        this.approvedUser = obj.approvedUser || '';
        this.theme = obj.theme;
        // Alternative name -> do we need this here?
        this.thematicArea = obj.thematicArea;
        this.legalArea = obj.legalArea;
        this.lectors = [];
        if (obj.lectors) {
            obj.lectors.forEach(lector => {
                this.lectors.push(lector);
            });
        }
        // TODO: events for this theme???
    }
}

export class AnnualCatalogModel {
    constructor(obj = {}) {
        this.id = obj.id || '';
        this.year = obj.year || new Date().getFullYear();
        this.createdDate = obj.createdDate ? new Date(obj.createdDate) : '';
        this.approvedUserId = obj.approvedUserId || '';
        this.approvedUser = obj.approvedUser || '';
        this.items = [];
        if (obj.items) {
            obj.items.forEach(item => {
                this.items.push(new AnnualCatalogItemModel(item));
            });
        }
    }
}

export class AnnualCatalogItemModel {
    constructor(obj = {}) {
        this.id = obj.id || '';
        this.theme = obj.theme || '';
        // this.alternativeName = obj.alternativeName || '';
        // this.legalAreaId = obj.legalAreaId || '';
        this.legalArea = obj.legalArea || '';
        this.thematicArea = obj.thematicArea || '';
        // this.proposedLectorsIds = obj.proposedLectorsIds || [];
        this.lectors = obj.lectors || [];
    }
}

export class EvaluationCriteriaSetModel {
    constructor(obj = {}) {
        this.id = obj.id || 0;
        this.registerEntityId = obj.registerEntityId || 0;
        this.name = obj.name || '';
        this.nameEn = obj.nameEn || '';
        this.isTemplate = obj.isTemplate || false;
        this.createdBy = obj.createdBy || '';
        this.createdAtUtc = obj.createdAtUtc || null;
        this.createdByUsername = obj.createdByUsername || '';
        this.criteria = [];
        if (obj.criteria) {
            obj.criteria.forEach(criteria => {
                this.criteria.push(new EvaluationCriteriaModel(criteria));
            })
        }
    }
}

export class EvaluationCriteriaModel {
    constructor(obj = {}) {
        this.id = obj.id || 0;
        this.criteriaToCriteriaSetId = obj.criteriaToCriteriaSetId || 0;
        this.code = obj.code || '';
        this.name = obj.name || '';
        this.nameEn = obj.nameEn || '';
        this.note = obj.note || '';
        this.additionallyAdded = obj.additionallyAdded || false;
        this.decimalValue = obj.decimalValue || null;
        this.datetimeValue = obj.datetimeValue ? new Date(obj.datetimeValue) : null;
        this.booleanValue = obj.booleanValue || null;
        this.textValue = obj.textValue || null;
        this.score = obj.score || null;
        this.criteriaType = obj.criteriaType || 0;
        this.createdBy = obj.createdBy || '';
        this.createdAtUtc = obj.createdAtUtc || null;
        this.createdByUsername = obj.createdByUsername || '';
        this.updatedBy = obj.updatedBy || '';
        this.updatedByUsername = obj.createdByUsername || '';
        this.updatedAtUtc = obj.updatedAtUtc || null;
        this.formFieldId = obj.formFieldId || null;
        this.operator = obj.operator || null;
        this.formFieldName = obj.formFieldName || '';
        this.formFieldCode = obj.formFieldCode || '';
        this.fieldType = obj.fieldType || '';
        this.inputType = obj.inputType || '';
        this.numberType = obj.numberType || '';
    }
}

export class NotificationConfig {
    constructor(obj = {}) {
        this.id = obj.id || 0;
        this.notificationTypeId = obj.notificationTypeId || 0;
        this.notificationType = obj.notificationType || '';
        this.messageContent = obj.messageContent || '';
        this.messageSubject = obj.messageSubject || '';
        this.keywords = obj.keywords || '';
    }
}

export class UpdateNotification {
    constructor(obj = {}) {
        this.id = obj.id || 0;
        this.otherNotification = obj.otherNotification || false;
        this.otherNotificationAt = obj.otherNotificationAt ? new Date(obj.otherNotificationAt) : null;
        this.otherNotificationNote = obj.otherNotificationNote || '';
    }
}

export class PersonSearchModel {
    constructor(obj = {}) {
        this.id = obj.id || '';
        this.firstName = obj.firstName || '';
        this.middleName = obj.middleName || '';
        this.lastName = obj.lastName || '';
        this.position = obj.position || '';
        this.institution = obj.institution || '';
        this.institutionEn = obj.institutionEn || '';
        this.institutionLocation = obj.institutionLocation || ''
        this.institutionLocationEn = obj.institutionLocationEn || ''
        this.email = obj.email || '';
        this.username = obj.username || '';
        this.identificationNumber = obj.identificationNumber || '';
        this.personSearchType = obj.personSearchType || PersonSearchType.Person;
        this.idCardDateOfIssue = obj.idCardDateOfIssue ? convertFromUtcToLocal(obj.idCardDateOfIssue) : null;
        this.includeMergedProfiles = obj.includeMergedProfiles || false;
    }
}


export class AreaOfAppeal {
    constructor(obj = {}) {
        this.cityId = obj.cityId || 0;
        this.name = obj.name || '';
        this.nameEn = obj.nameEn || '';
        this.districtCode = obj.districtCode || '';
    }
}

export class TempRanking {
    constructor(obj = {}) {
        this.id = obj.id || 0;
        this.registerEntityId = obj.registerEntityId || 0;
        this.name = obj.name || '';
        this.isActive = obj.isActive || false;
        this.accommodationRequestRequired = obj.accommodationRequestRequired || false;
        this.eventName = obj.eventName || '';
        this.studentsMaxNum = obj.studentsMaxNum || 0;
        this.isValid = obj.isValid || false;
        this.ver = obj.ver || 0;
        this.creatorUsername = obj.creatorUsername || '';
        this.createdAt = obj.createdAt ? new Date(obj.createdAt) : null;
        this.updaterUsername = obj.updaterUsername || '';
        this.updatedAt = obj.updatedAt ? new Date(obj.updatedAt) : null;
        this.confirmMaxDate = obj.confirmMaxDate ? new Date(obj.confirmMaxDate) : null;
        this.admittedCount = obj.admittedCount || 0;
        this.reserveCount = obj.reserveCount || 0;
        this.rejectedCount = obj.rejectedCount || 0;
        this.eventStartDate = obj.eventStartDate ? new Date(obj.eventStartDate) : null;
        this.eventEndDate = obj.eventEndDate ? new Date(obj.eventEndDate) : null;
        this.confirmDateMinRange = obj.confirmDateMinRange ? new Date(obj.confirmDateMinRange) : null;
        this.confirmDateMaxRange = obj.confirmDateMaxRange ? new Date(obj.confirmDateMaxRange) : null;
    }
}

export class ScheduleTask {
    constructor(obj = {}) {
        this.id = obj.id || 0;
        this.title = obj.title || '';
        this.description = obj.description || '';
        this.placeId = obj.placeId || '';
        this.placeIdStr = obj.placeIdStr || '';
        this.hallId = obj.hallId || '';
        this.hallIdStr = obj.hallIdStr || '';
        this.startTime = obj.startTime ? obj.startTime : null;
        this.endTime = obj.endTime ? obj.endTime : null;
        this.eventId = obj.eventId || '';
        this.eventIdStr = obj.eventIdStr || '';
        this.eventName = obj.eventName || '';
        this.eventStartTime = obj.eventStartTime ? convertFromUtcToLocal(obj.eventStartTime) : null;
        this.eventEndTime = obj.eventEndTime ? convertFromUtcToLocal(obj.eventEndTime) : null;
        this.isAllDay = obj.isAllDay || false;
        this.createdAtUtc = obj.createdAtUtc ? convertFromUtcToLocal(obj.createdAtUtc) : null;
        this.updatedAtUtc = obj.updatedAtUtc ? convertFromUtcToLocal(obj.updatedAtUtc) : null;
        this.lecturersPersonIds = obj.lecturersPersonIds || [];
        this.coordinatorsPersonIds = obj.coordinatorsPersonIds || [];
        this.mapVenueToEvent = obj.mapVenueToEvent || false;
        this.hideFromDescription = obj.hideFromDescription || false;
        this.startMinDate = obj.startMinDate ? convertFromUtcToLocal(obj.startMinDate) : null;
        this.startMaxDate = obj.startMaxDate ? convertFromUtcToLocal(obj.startMaxDate) : null;
        this.endMinDate = obj.endMinDate ? convertFromUtcToLocal(obj.endMinDate) : null;
        this.endMaxDate = obj.endMaxDate ? convertFromUtcToLocal(obj.endMaxDate) : null;
        this.uid = Math.floor((Math.random()) * 0x10000).toString(16);
        this.isInEditMode = obj.isInEditMode || false;
        this.expanded = obj.isInEditMode || false;
        this.isDailyEven = false;

        this.placeName = obj.placeName || '';
        this.placeNameEn = obj.placeNameEn || '';
        this.hallName = obj.hallName || '';
        this.hallNameEn = obj.hallNameEn || '';

        this.lecturersNamesList = [];
        if (obj.lecturersNamesList) {
            obj.lecturersNamesList.forEach(item => {
                this.lecturersNamesList.push(item);
            })
        }

        this.coordinatorsNamesList = [];
        if (obj.coordinatorsNamesList) {
            obj.coordinatorsNamesList.forEach(item => {
                this.coordinatorsNamesList.push(item);
            })
        }
    }
}

export class Absence {
    constructor(obj = {}) {
        this.id = obj.id || '';
        this.employeeId = obj.employeeId || '';
        this.absenceDate = obj.absenceDate || '';
        this.absenceEndDate = obj.absenceEndDate || '';
        this.absenceTypeId = obj.absenceTypeId || '';
        this.substitutionEmployeeId = obj.substitutionEmployeeId || '';
        this.reasonForAbsence = obj.reasonForAbsence || '';
        this.reasonForReplacement = obj.reasonForReplacement || '';
        this.userId = obj.userId || '';
        this.allEmployees = obj.allEmployees || false;
    }
}

export class BudgetPlanningModel {
    constructor(obj = {}) {
        this.id = obj.id || '';
        this.isFromTemplate = obj.isFromTemplate || false;
        this.isExpensesGenerated = obj.isExpensesGenerated || false;
        this.registerEntityId = obj.registerEntityId || '';
        this.name = obj.name || '';
        this.nameEn = obj.nameEn || '';
        this.isTemplate = obj.isTemplate || false;
        this.fileIdsToDelete = [];
        this.itemsToDelete = [];
        this.items = [];
        if (obj.items) {
            obj.items.forEach(item => {
                this.items.push(new BudgetPlanningRowModel(item));
            })
        }
    }
}

export class BudgetPlanningRowModel {
    constructor(obj = {}) {
        this.id = obj.id || '';
        this.groupName = obj.groupName || '';
        this.tariffEntityItemId = obj.tariffEntityItemId || '';
        this.tariffEntityItem = obj.tariffEntityItem || '';
        this.tariffEntityToTariffItemId = obj.tariffEntityToTariffItemId || '';
        this.description = obj.description || '';
        this.date = obj.date ? new Date(obj.date) : '';
        this.timeFrom = obj.timeFrom || '';
        this.timeTo = obj.timeTo || '';
        this.qty = obj.qty || 0;
        this.price = obj.price || 0;
        this.total = obj.total || 0;
        this.files = [];
        this.uid = getUid();
        if (obj.files) {
            obj.files.forEach(file => {
                this.files.push(new BudgetReportFileModel(file));
            });
        }

        this.relatedExepense = obj.relatedExepense ? new BudgetPlanningRowModel(obj.relatedExepense) : null;
        this.lastUpdateDate = obj.lastUpdateDate;
        this.lastUpdater = obj.lastUpdater;
        this.selectedTariffText = obj.selectedTariffText;
    }
}

export class BudgetReportModel {
    constructor(obj = {}) {
        this.registerEntityId = obj.registerEntityId || '';
        this.filesToDelete = [];
        this.isNew = obj.isNew;
        this.items = [];
        if (obj.items) {
            obj.items.forEach(item => {
                this.items.push(new BudgetReportItemModel(item));
            })
        }
    }
}

export class BudgetReportItemModel {
    constructor(obj = {}) {
        this.id = obj.id || '';
        this.uid = obj.uid || '';
        this.personId = obj.personId || '';
        this.personName = obj.personName || '';
        this.personNameEn = obj.personNameEn || '';
        this.businessTripOrderNumber = obj.businessTripOrderNumber || '';
        this.businessTripDateFrom = obj.businessTripDateFrom || '';
        this.businessTripDateTo = obj.businessTripDateTo || '';
        this.days = obj.days || '';
        this.moneyDayRate = obj.moneyDayRate || '';
        this.daySum = obj.daySum || '';
        this.nightsFrom = obj.nightsFrom || '';
        this.nightsTo = obj.nightsTo || '';
        this.nightsCount = obj.nightsCount || '';
        this.singlePrice = obj.singlePrice || '';
        this.appartmentSum = obj.appartmentSum || '';
        this.roadGoingMoney = obj.roadGoingMoney || '';
        this.roadGoingDate = obj.roadGoingDate || '';
        this.roadReturningMoney = obj.roadReturningMoney || '';
        this.roadReturningDate = obj.roadReturningDate || '';
        this.allMoneySum = obj.allMoneySum || '';
        this.paymentDate = obj.paymentDate || '';
        this.paidExpenses = obj.paidExpenses || '';
        this.excerpt = obj.excerpt || '';
        this.accountingProgram = obj.accountingProgram || ''; // TODO: Sum
        // TODO: Remove from db and backend this.difference = obj.difference || '';
        this.notes = obj.notes || '';
        this.financialControl = obj.financialControl || false;
        this.disalbedForEdit = obj.disalbedForEdit || false;
        this.files = [];
        if (obj.files) {
            obj.files.forEach(file => {
                this.files.push(new BudgetReportFileModel(file));
            });
        }
    }
}

export class DropdownModel {
    constructor(obj = {}) {
        this.id = obj.id || '';
        this.parentId = obj.parentId || '';
        this.text = obj.text || '';
        this.textEn = obj.textEn || '';
        this.checked = obj.checked || false;
        this.color = obj.color || '';
    }
}

export class CalendarSettingsModel {
    constructor(obj = {}) {
        this.itemTypes = [];
        this.itemFilters = [];
        this.taskStatuses = [];
        this.selectedFilter = obj.selectedFilter || '';
        this.directorateId = obj.directorateId || '';
        this.taskStatusId = obj.tastStatusId || ''

        if (obj.itemTypes) {
            obj.itemTypes.forEach(item => {
                this.itemTypes.push(new DropdownModel(item));
            })
        }

        if (obj.itemFilters) {
            obj.itemFilters.forEach(item => {
                this.itemFilters.push(new DropdownModel(item));
            })
        }

        if (obj.taskStatuses) {
            obj.taskStatuses.forEach(item => {
                this.taskStatuses.push(new DropdownModel(item));
            })
        }
    }
}

export class EventsGridSettingsModel {
    constructor(obj = {}) {
        this.directoratesIds = obj.directoratesIds || [];
    }
}

export class EventsOutOfCatalogGridSettingsModel {
    constructor(obj = {}) {
        this.annualCatalogId = obj.annualCatalogId || 0;
    }
}

export class SchedulerCalendarSettingsModel {
    constructor(obj = {}) {
        this.placeId = obj.placeId || '';
        this.halls = obj.halls || [];
    }
}

export class EventDetails {
    constructor(obj = {}) {
        this.registerEntityId = obj.registerEntityId || '';
        this.eventName = obj.eventName || '';
        this.eventStartDate = obj.eventStartDate ? obj.eventStartDate : null;
        this.eventEndDate = obj.eventEndDate ? obj.eventEndDate : null;
        this.eventSubscriptionStartDate = obj.eventSubscriptionStartDate ? new Date(obj.eventSubscriptionStartDate) : null;
        this.eventSubscriptionEndDate = obj.eventSubscriptionEndDate ? new Date(obj.eventSubscriptionEndDate) : null;
        this.statusName = obj.statusName || '';
        this.statusNameEn = obj.statusNameEn || '';
        this.eventForm = obj.eventForm || '';
        this.eventType = obj.eventType || '';
        this.appEventSettings = new AppEventSettings(obj.appEventSettings || {});

        this.lecturers = [];
        this.coordinators = [];
        if (obj.lecturers) {
            obj.lecturers.forEach(lecturer => {
                this.lecturers.push(new Person(lecturer));
            })
        }
        if (obj.coordinators) {
            obj.coordinators.forEach(coordinator => {
                this.coordinators.push(new PersonDetails(coordinator));
            })
        }
    }
}

export class OrganizationalModel {
    constructor(obj = {}) {
        this.id = obj.id || '';
        this.name = obj.name || '';
        this.nameEn = obj.nameEn || '';
        this.description = obj.description || '';
        this.deactivated = obj.deactivated || false;
        this.createdBy = obj.createdBy || '';
        this.createdAt = obj.createdAt ? convertFromUtcToLocal(obj.createdAt) : null;
        this.eventFormIds = obj.eventFormIds || [];
        this.eventActivityIds = obj.eventActivityIds || [];
        this.loaded = obj.loaded || false;
        this.checked = obj.checked || false;
        this.eventForms = obj.eventForms || '';
        this.eventFormsEn = obj.eventFormsEn || '';
        this.eventActivities = obj.eventActivities || '';
        this.eventActivitiesEn = obj.eventActivitiesEn || '';
    }
}

export class OrganizationalCalendar {
    constructor(obj = {}) {
        this.id = obj.id || '';
        this.registerEntityId = obj.registerEntityId || '';
        this.name = obj.name || '';
        this.nameEn = obj.nameEn || '';
        this.description = obj.description || '';
        this.applied = obj.applied || false;
        this.deleted = obj.deleted || false;
        this.createdBy = obj.createdBy || '';
        this.createdAt = obj.createdAtUtc ? convertFromUtcToLocal(obj.createdAtUtc) : null;
    }
}

export class AspNetUser {
    constructor(obj = {}) {
        this.id = obj.id || '';
        this.userName = obj.userName || '';
        this.email = obj.email || '';
        this.newPassword = '';
        this.roles = [];
        this.deleted = obj.deleted || false;
        this.updatedBy = obj.updatedBy || '';
        this.updatedAt = obj.updatedAt ? obj.updatedAt : null;
        this.lastLogTime = obj.lastLogTime ? obj.lastLogTime : null;
        this.selectedRoles = [];

        if (obj.moodleUserAccountDetails) {
            this.moodleUserAccountDetails = new MoodleUserAccountDetails(obj.moodleUserAccountDetails);
        } else {
            this.moodleUserAccountDetails = new MoodleUserAccountDetails();
        }

        if (obj.roles) {
            obj.roles.forEach(role => {
                this.roles.push(role);
            })
        }

        if (obj.selectedRoles) {
            obj.selectedRoles.forEach(id => {
                this.selectedRoles.push(id);
            })
        }

        this.deleteMoodleSync = '';
        this.firstName = obj.firstName || '';
        this.middleName = obj.middleName || '';
        this.lastName = obj.lastName || '';
        this.description = obj.description || '';

        this.canSignDocument = obj.canSignDocument;
        if (obj.signatureImageDocuments) {
            this.signatureImageDocuments = [];
            for (let i = 0; i < obj.signatureImageDocuments.length; i++) {
                this.signatureImageDocuments.push(new File(obj.signatureImageDocuments[i]));
            }
        } else {
            this.signatureImageDocuments = [];
        }
    }
}

export class Nomenclature {
    constructor(obj = {}) {
        this.id = obj.id || 0;
        this.parentId = obj.parentId || '';
        this.parentModel = new NomenclatureParent(obj.parentModel);
        this.name = obj.name || '';
        this.nameEn = obj.nameEn || '';
        this.description = obj.description || '';
        this.sort = obj.sort || '';
        this.deactivated = obj.deactivated || false;
        this.deleted = obj.deleted || false;
        this.updated = obj.updated || false;
    }
}

export class ForeignCity {
    constructor(obj = {}) {
        this.id = obj.id || '';
        this.parentId = obj.parentId || 0;// Cities.ForeignCity;
        this.name = obj.name || '';
        this.nameEn = obj.nameEn || '';
        this.sort = obj.sort || 0;
        this.description = obj.description || '';
        this.deactivated = obj.deactivated || false;
        this.deleted = obj.deleted || false;
        this.updated = obj.updated || false;
    }
}

export class NomenclatureParent {
    constructor(obj = {}) {
        this.id = obj.id || '';
        this.text = obj.text || '';
        this.textEn = obj.textEn || '';
    }
}

export class StaticRegistersForDropdown {
    constructor(obj = {}) {
        this.id = obj.id || '';
        this.registerId = obj.registerId || '';
        this.staticRegisterName = obj.staticRegisterName || '';
        this.displayMember = obj.displayMember || '';
        this.description = obj.description || '';
        this.schema = obj.schema || '';
        this.deactivated = obj.deactivated || false;
        this.allowAnonymousAccesss = obj.allowAnonymousAccesss || false;
    }
}

export class BudgetModuleModel {
    constructor(obj = {}) {
        this.id = obj.id || '';
        this.year = obj.year || '';
        this.items = [];
        if (obj.items && obj.items.length > 0) {
            obj.items.forEach(item => {
                this.items.push(new BudgetModuleItemModel(item));
            });
        }
    }
}

export class BudgetModuleItemModel {
    constructor(obj = {}) {
        this.id = obj.id || '';
        this.groupName = obj.groupName || '';
        this.tariffItemId = obj.tariffItemId || '';
        this.tariffEntityToTariffItemId = obj.tariffEntityToTariffItemId || '';
        this.itemName = obj.itemName || '';
        this.itemNameEn = obj.itemNameEn || '';
        this.itemCode = obj.itemCode || '';
        this.qty = obj.qty || 0;
        this.priceId = obj.priceId || '';
        this.price = obj.price || 0;

        this.expenseQty = obj.expenseQty || 0;
        this.expensePrice = obj.expensePrice || 0;
        this.financingId = obj.financingId || '';

        this.total = Math.round((obj.total || this.qty * this.price) * 100) / 100;
        this.expenseTotal = Math.round((obj.expenseTotal || this.expenseQty * this.expensePrice) * 100) / 100;
    }
}

export class UpcomingEvent {
    constructor(obj = {}) {
        this.id = obj.id || '';
        this.name = obj.name || '';
        this.nameEn = obj.nameEn || '';
        this.startTimeUtc = obj.startTimeUtc ? obj.startTimeUtc : null;
        this.endTimeUtc = obj.endTimeUtc ? obj.endTimeUtc : null;
        this.subscriptionStartTimeUtc = obj.subscriptionStartTimeUtc ? obj.subscriptionStartTimeUtc : null;
        this.subscriptionEndTimeUtc = obj.subscriptionEndTimeUtc ? obj.subscriptionEndTimeUtc : null;
        this.subscriptionFormId = obj.subscriptionFormId || '';
        this.subscriptionFormDeactivated = obj.SubscriptionFormDeactivated || false;
        this.tempRankingId = obj.tempRankingId || '';
        this.hasPendingConfirmation = obj.hasPendingConfirmation || false;
        this.confirmed = obj.confirmed || false;
        this.rejected = obj.rejected || false;
        this.canSubscribe = obj.canSubscribe || false;
        this.canEditSubscriptionEntry = obj.canEditSubscriptionEntry || false;
        this.canSubscribeForEventNotification = obj.canSubscribeForEventNotification || false;
        this.canUnsubscribeForEventNotification = obj.canUnsubscribeForEventNotification || false;
        this.canConfirmEventSubscriptionRequest = obj.canConfirmEventSubscriptionRequest || false;
        this.canEditEventSubscriptionRequest = obj.canEditEventSubscriptionRequest || false;
        this.canRejectEventSubscriptionRequest = obj.canRejectEventSubscriptionRequest || false;
        this.statuses = obj.statuses || '';
        this.accommodationRequestRequired = obj.accommodationRequestRequired || false;
        this.accommodationFromTimeUtc = obj.accommodationFromTimeUtc ? obj.accommodationFromTimeUtc : null;
        this.accommodationToTimeUtc = obj.accommodationToTimeUtc ? obj.accommodationToTimeUtc : null;
        this.eventContactPerson = obj.eventContactPerson;
        this.eventAudience = obj.eventAudience;
        this.participationDetailsId = obj.participationDetailsId;
    }
}

export class NotificationSubscription {
    constructor(obj = {}) {
        this.id = obj.id || '';
        this.eventId = obj.eventId || '';
        this.email = obj.email || '';
        this.note = obj.note || '';
    }
}

export class ParticipationType {
    constructor(obj = {}) {
        this.id = obj.id || 0;
        this.name = obj.name || '';
        this.nameEn = obj.nameEn || '';
        this.code = obj.code || 0;
        this.description = obj.description || '';
        this.isParticipation = obj.isParticipation || false;
        this.isLecturerType = obj.isLecturerType || false;
        this.isCoordinatorType = obj.isCoordinatorType || false;
        this.deactivated = obj.deactivated || false;
        this.participationRelationTypes = obj.participationRelationTypes || [];
        this.reasonForAdmissions = obj.reasonForAdmissions || [];
    }
}

export class ParticipationRelationType {
    constructor(obj = {}) {
        this.id = obj.id || 0;
        this.name = obj.name || '';
        this.nameEn = obj.nameEn || '';
        this.sort = obj.sort || 1;
        this.description = obj.description || '';
        this.deactivated = obj.deactivated || false;
        this.participationTypes = [];
        this.participationTypesModels = [];
        if (obj.participationTypesModels && obj.participationTypesModels.length > 0) {
            obj.participationTypesModels.forEach(item => {
                this.participationTypesModels.push(new ParticipationType(item));
                this.participationTypes.push(item.id)
            });
        }
    }
}

export class InputEvent {
    constructor(obj = {}) {
        this.name = obj.name || '';
        this.type = obj.type || '';
        this.isCheckbox = obj.isCheckbox || false;
        this.value = obj.value || '';
        this.valueAsDate = obj.valueAsDate || null;
        this.valueAsNumber = obj.valueAsNumber || null;
        this.checked = obj.checked || false;
    }
}

export class TempRankingToPersonModel {
    constructor(obj = {}) {
        this.id = obj.id || '';
        this.participantName = obj.participantName;
        this.participantNameEn = obj.participantNameEn;
        this.registerEntityId = obj.registerEntityId || 0;
        this.eventName = obj.eventName || '';
        this.eventStartDate = obj.eventStartDate ? obj.eventStartDate : null;
        this.tempRankingAccommodationRequestRequired = obj.tempRankingAccommodationRequestRequired;
        this.eventEndDate = obj.eventEndDate ? obj.eventEndDate : null;
        this.accommodationFromTimeUtc = obj.accommodationFromTimeUtc ? obj.accommodationFromTimeUtc : null;
        this.accommodationToTimeUtc = obj.accommodationToTimeUtc ? obj.accommodationToTimeUtc : null;
        this.confirmMaxDate = obj.confirmMaxDate ? obj.confirmMaxDate : null;
        this.isConfirmed = obj.isConfirmed || false;
        this.isRejected = obj.isRejected || false;
        this.note = obj.note || '';
        this.isManualAddition = obj.isManualAddition || '';
        this.isNotifiedByPhone = obj.isNotifiedByPhone || '';
        this.dateOfNotificationUtc = obj.dateOfNotificationUtc ? obj.dateOfNotificationUtc : null;
        this.phoneOfNotificatiob = obj.phoneOfNotificatiob || '';


        if (obj.participationDetails) {
            this.participationDetails = new ParticipationDetailsModel(obj.participationDetails)
        } else {
            this.participationDetails = new ParticipationDetailsModel()
        }
    }
}

export class ParticipationDetailsModel {
    constructor(obj = {}) {
        this.id = obj.id || '';
        this.accommodationRequired = obj.accommodationRequired || false;
        this.transportationRequired = obj.transportationRequired || false;
        this.vegetarianMenuRequired = obj.vegetarianMenuRequired || false;
        this.participantName = obj.participantName;
        this.participantNameEn = obj.participantNameEn;
        this.note = obj.note || '';

        if (obj.accommodationRequest) {
            this.accommodationRequest = new AccommodationRequestModel(obj.accommodationRequest)
        } else {
            this.accommodationRequest = new AccommodationRequestModel()
        }
    }
}

export class AccommodationRequestModel {
    constructor(obj = {}) {
        this.id = obj.id || '';
        this.accommodationPlaceId = obj.accommodationPlaceId || '';
        this.accommodationTypeId = obj.accommodationTypeId || '';
        this.fromDate = obj.fromDate ? obj.fromDate : null;
        this.toDate = obj.toDate ? obj.toDate : null;
    }
}

export class AccommodationRequestDeatilsModel {
    constructor(obj = {}) {
        this.participationDetailsId = obj.participationDetailsId || '';
        this.accommodationRequired = obj.accommodationRequired || false;
        this.transportationRequired = obj.transportationRequired || false;
        this.vegetarianMenuRequired = obj.vegetarianMenuRequired || false;
        this.participationDetailsNote = obj.participationDetailsNote || '';
        this.fromUtc = obj.fromUtc ? obj.fromUtc : null;
        this.toUtc = obj.toUtc ? obj.toUtc : null;
        this.accommodationPlaceName = obj.accommodationPlaceName || '';
        this.accommodationPlaceNameEn = obj.accommodationPlaceNameEn || '';
        this.singleRoom = obj.singleRoom || false;
        this.doubleRoom = obj.doubleRoom || false;
        this.tripleRoom = obj.tripleRoom || false;
        this.apartment = obj.apartment || false;
        this.rankingConfirmationId = obj.rankingConfirmationId || '';
        this.confirmedByAdmin = obj.confirmedByAdmin || '';
        this.isNotifiedByPhone = obj.isNotifiedByPhone || '';
        this.dateOfNotificationUtc = obj.dateOfNotificationUtc ? obj.dateOfNotificationUtc : null;
        this.phoneOfNotificatiob = obj.phoneOfNotificatiob || '';
    }
}

export class ConfirmationRejectionDetailsModel {
    constructor(obj = {}) {
        this.id = obj.id || '';
        this.timeUtc = obj.timeUtc || '';
        this.user = obj.user || '';
        this.rejectedByAdmin = obj.rejectedByAdmin || false;
        this.note = obj.note || '';
    }
}

export class LocalizationFilesModel {
    constructor(obj = {}) {
        this.bgContent = obj.bgContent || '';
        this.enContent = obj.enContent || '';
        this.merge = obj.merge || false;
    }
}

export class ActionLogModel {
    constructor(obj = {}) {
        this.id = obj.id || '';
        this.description = obj.description || '';
        this.time = obj.time ? obj.time : null;
    }
}

export class DynamicRegisterFieldValueViewModel {
    constructor(obj = {}) {
        this.fieldValueId = obj.fieldValueId || '';
        this.registerEntityId = obj.registerEntityId || '';
        this.fieldId = obj.fieldId || '';
        this.contrainerId = obj.contrainerId || '';
        this.containerSort = obj.containerSort || '';
        this.containerLabel = obj.containerLabel || '';
        this.containerLabelEn = obj.containerLabelEn || '';
        this.fieldSort = obj.fieldSort || '';
        this.fieldLabel = obj.fieldLabel || '';
        this.fieldLabelEn = obj.fieldLabelEn || '';
        this.description = obj.description || '';
        this.descriptionEn = obj.descriptionEn || '';
        this.fieldType = obj.fieldType || '';
        this.showInDescription = obj.showInDescription || '';
        this.fieldCode = obj.fieldCode || '';
        this.intValue = obj.intValue || '';
        this.decimalValue = obj.decimalValue || '';
        this.datetimeValue = obj.datetimeValue ? obj.datetimeValue : null;
        this.boolValue = obj.boolValue || '';
        this.textValue = obj.textValue || '';
        this.fkStrValue = obj.fkStrValue || '';
        this.fkStrValueEn = obj.fkStrValueEn || '';
        this.stringValue = obj.stringValue || '';
        this.stringValueEn = obj.stringValueEn || '';
    }
}

export class DynamicRegisterContainerDetails {
    constructor(obj = {}) {
        this.contrainerId = obj.contrainerId || '';
        this.containerSort = obj.containerSort || '';
        this.containerLabel = obj.containerLabel || '';
        this.containerLabelEn = obj.containerLabelEn || '';
        this.fields = [];

        if (obj.fields && obj.fields.length > 0) {
            obj.fields.forEach(item => {
                this.fields.push(new DynamicRegisterFieldValueViewModel(item));
            });
        }
    }
}


export class DynamicRegisterDetails {
    constructor(obj = {}) {
        this.registerEntityId = obj.registerEntityId || '';
        this.eventName = obj.eventName || '';
        this.containers = [];

        if (obj.containers && obj.containers.length > 0) {
            obj.containers.forEach(item => {
                this.containers.push(new DynamicRegisterContainerDetails(item));
            });
        }
    }
}

export class DynamicFormDetails {
    constructor(obj = {}) {
        this.formEntityId = obj.formEntityId || '';
        this.formName = obj.formName || '';
        this.formNameEn = obj.formNameEn || '';
        this.registerEntityId = obj.registerEntityId || '';
        this.eventName = obj.eventName || '';
        this.creatorFullName = obj.creatorFullName || '';
        this.createdAtUtc = obj.createdAtUtc ? obj.createdAtUtc : null;
        this.updatedAtUtc = obj.updatedAtUtc ? obj.updatedAtUtc : null;
        this.containers = [];

        if (obj.containers && obj.containers.length > 0) {
            obj.containers.forEach(item => {
                this.containers.push(new DynamicRegisterContainerDetails(item));
            });
        }
    }
}

export class AppUserSettings {
    constructor(obj = {}) {
        this.code = obj.code || '';
        this.defaultUserRoleId = obj.defaultUserRoleId || '';
    }
}

export class AppEventSettings {
    constructor(obj = {}) {
        this.code = obj.code || '';
        this.createNewFormOnAddToEvent = obj.createNewFormOnAddToEvent || false;
        this.checkEventTimeRangeOnFormAddToEvent = obj.checkEventTimeRangeOnFormAddToEvent || false;
        this.checkEventSubscriptionTimeRangeOnFormAddToEvent = obj.checkEventSubscriptionTimeRangeOnFormAddToEvent || false;
        this.skipRankingQuotaEvaluation = obj.skipRankingQuotaEvaluation || false;
        this.rankWithNoneQuotes = obj.rankWithNoneQuotes || false;
        this.rerankDropoutFromQuota = obj.rerankDropoutFromQuota || false;
        this.createInstitutionOnParticipantsImport = obj.createInstitutionOnParticipantsImport || false;
        this.moodleEventNameComposingPattern = obj.moodleEventNameComposingPattern || '';
        this.filterParticipationRelationTypeByParticipationType = obj.filterParticipationRelationTypeByParticipationType || false;
        this.filterReasonForAdmissionByParticipationType = obj.filterReasonForAdmissionByParticipationType || false;
        this.accommodationRequestDaterangeMinLimitToFieldRelation = obj.accommodationRequestDaterangeMinLimitToFieldRelation || null;
        this.accommodationRequestDaterangeMaxLimitToFieldRelation = obj.accommodationRequestDaterangeMaxLimitToFieldRelation || null;
        this.accommodationRequestDaterangeLimitToEventsSkip = obj.accommodationRequestDaterangeLimitToEventsSkip || [];
    }
}

export class AppIsupoSettings {
    constructor(obj = {}) {
        this.code = obj.code || '';
        this.schema = obj.schema || '';
        this.hostName = obj.hostName || '';
        this.migrateParticipantsInSingleStatement = obj.migrateParticipantsInSingleStatement || false;
        this.migrateParticipantsBatchSize = obj.migrateParticipantsBatchSize || '';
        this.showDraftReports = obj.showDraftReports || false;
        this.loadLocalizationFromDb = obj.loadLocalizationFromDb || false;
        this.includeMergedProfiles = obj.includeMergedProfiles || false;
    }
}

export class AppFormSettings {
    constructor(obj = {}) {
        this.formTypesWithAnonymousFillingAllowed = obj.formTypesWithAnonymousFillingAllowed || [];
    }
}

export class RankingCriteria {
    constructor(obj = {}) {
        this.id = obj.id || '';
        this.registerEntityId = obj.registerEntityId || '';
        this.name = obj.name || '';
        this.nameEn = obj.nameEn || '';
        this.other1 = obj.other1 || '';
        this.other2 = obj.other2 || '';
        this.deactivated = obj.deactivated || false;
        this.rankingData = new RankingData(obj.rankingData || {});
        this.creatorUsername = obj.creatorUsername || '';
        this.createdAtUtc = obj.createdAtUtc ? obj.createdAtUtc : null;
        this.updaterUsername = obj.updaterUsername || '';
        this.updatedAtUtc = obj.updatedAtUtc ? obj.updatedAtUtc : null;
        this.copyToRegister = obj.copyToRegister || false;
        this.eventFormIds = obj.eventFormIds || [];
    }
}

export class RankingData {
    constructor(obj = {}) {
        this.rule = new RankingRule(obj.rule || {});
        this.exception = new RankingException(obj.exception || {})
        this.constraints = [];
        this.quotas = [];

        if (obj.constraints && obj.constraints.length > 0) {
            obj.constraints.forEach(item => {
                this.constraints.push(new RankingConstraint(item));
            });
        }

        if (obj.quotas && obj.quotas.length > 0) {
            obj.quotas.forEach(item => {
                this.quotas.push(new RankingQuota(item));
            });
        }
    }
}


export class RankingRule {
    constructor(obj = {}) {
        this.firstInTimeFirstInLaw = obj.firstInTimeFirstInLaw || false;
    }
}

export class RankingException {
    constructor(obj = {}) {
        this.manuallyAdded = obj.manuallyAdded || false;
    }
}

export class RankingConstraint {
    constructor(obj = {}) {
        this.uid = obj.uid || '';
        this.code = obj.code || '';
        this.constraintType = obj.constraintType || '';
        this.evaluationCriteriaType = obj.evaluationCriteriaType || '';
        this.evaluationCriteriaCode = obj.evaluationCriteriaCode || '';
        this.score = obj.score || '';
        this.isCurrentYear = obj.isCurrentYear || '';
        this.startDateUtc = obj.startDateUtc ? obj.startDateUtc : null;
        this.endDateUtc = obj.endDateUtc ? obj.endDateUtc : null;
        this.filterValue = obj.filterValue || '';
        this.setCount = obj.setCount || '';
        this.minMaxType = obj.minMaxType || '';
        this.count = obj.count || '';
        this.notParticipatesInOverlappingEvent = obj.notParticipatesInOverlappingEvent || false;
        this.hasConsentOfTheManager = obj.hasConsentOfTheManager || false;
        this.searchFieldName = obj.searchFieldName || '';
        this.fulfillment = obj.fulfillment || '';
    }
}

export class RankingQuota {
    constructor(obj = {}) {
        this.uid = obj.uid || '';
        this.code = obj.code || 'AppellateRegion';
        this.quotaType = obj.quotaType || 1;
        this.filterValue = obj.filterValue || '';
        this.filterValueEn = obj.filterValueEn || '';
        this.count = obj.count || '';
        this.operator = obj.operator || '';
        this.searchFieldName = obj.searchFieldName || '';
        this.fildType = obj.fildType || '';
        this.fulfillment = obj.fulfillment || '';
    }
}

export class TempRankingStatistics {
    constructor(obj = {}) {
        this.tempRankingId = obj.tempRankingId || '';
        this.studentsMaxNum = obj.studentsMaxNum || '';
        this.admittedCount = obj.admittedCount || '';
        this.rejectedCount = obj.rejectedCount || '';
        this.reserveCount = obj.reserveCount || '';
        this.participantsCount = obj.participantsCount || '';
        this.requestsCount = obj.requestsCount || '';
        this.requestsConfirmedCount = obj.requestsConfirmedCount || '';
        this.requestsRejectedCount = obj.requestsRejectedCount || '';
    }
}

export class EventDescription {
    constructor(obj = {}) {
        this.name = obj.name || '';
        this.startDate = obj.startDate ? new Date(obj.startDate) : '';
        this.endDate = obj.endDate ? new Date(obj.endDate) : '';
        this.place = obj.place || '';
        this.directorate = obj.directorate || '';
        this.projectName = obj.projectName || '';
        this.organizer = obj.organizer || '';
        this.lecturers = [];
        if (obj.lecturers) {
            obj.lecturers.forEach(lecturerName => {
                this.lecturers.push(lecturerName);
            });
        }
    }
}

export class DynamicLayoutPanelModel {
    constructor(obj = {}) {
        this.name = obj.name || '';
        this.label = obj.label || '';
        this.labelEn = obj.labelEn || '';
        this.sort = obj.sort || 1;
        this.size = obj.size || 0;
    }
}

export class MoodleUserCreateModel {
    constructor(obj = {}) {
        this.idnumber = obj.idnumber || '';
        this.userName = obj.userName || '';
        this.email = obj.email || '';
        this.firstName = obj.firstName || '';
        this.lastName = obj.lastName || '';
        this.middleName = obj.middleName || '';
        this.description = obj.description || '';
        this.createpassword = obj.createpassword || 1;
    }
}

export class MoodleUserAccountDetails {
    constructor(obj = {}) {
        this.moodleAccountSyncDetails = obj.moodleAccountSyncDetails || '';
        this.moodleAccountLink = obj.moodleAccountLink || '';
        this.userSyncedWithMoodle = obj.userSyncedWithMoodle || false;
        this.userExistingInMoodleButNotSynced = obj.userExistingInMoodleButNotSynced || false;
    }
}

export class FormParticipantModel {
    constructor(obj = {}) {
        this.registerEntityToPersonId = obj.registerEntityToPersonId;
        this.fullName = obj.fullName;
        this.fullNameEn = obj.fullNameEn;
        this.participationType = obj.participationType;
    }
}

export class UserHelp {
    constructor(obj = {}) {
        this.id = obj.id || '';
        this.name = obj.name || '';
        this.nameEn = obj.nameEn || '';
        this.parentId = obj.parentId || '';
        this.content = obj.content || '';
        this.contentEn = obj.contentEn || '';
        this.deactivated = obj.deactivated || false;
        this.sort = obj.sort || 0;
    }
}

export class OrganizationalCalendarSettings {
    constructor(obj = {}) {
        this.loadOnlyValidModels = obj.loadOnlyValidModels || '';
        this.calendarReapply = obj.calendarReapply || '';
        this.calendarItemReapply = obj.calendarItemReapply || '';
        this.calendarModelsANDFilter = obj.calendarModelsANDFilter || '';
    }
}

export class AdmittedMultipleUpdateModel {
    constructor(obj = {}) {
        this.modalTitle = obj.modalTitle || '';
        this.registerEntityId = obj.registerEntityId;
        this.items = obj.items || [];
    }
}


